import React, { useEffect, useState } from 'react';
import { useAuth } from '../Context/AuthContext';
import { toast } from 'react-toastify';

import { Card, Container, Row, Col, Modal, Button, Form } from 'react-bootstrap';

import { db } from '../firebase-config';
import { collection, query, where, onSnapshot, getDocs, getDoc, doc, runTransaction, /*updateDoc, getDoc, increment, serverTimestamp*/} from 'firebase/firestore';
import { getFunctions, httpsCallable } from "firebase/functions";

import { timestampToHTMLDateInput, HTMLDateInputToTimestamp, currentTimeStamp, calcHourTimeStampDiff } from '../HelperFunctions/dateConverters';
import CreateRequestModal from '../Modals/CreateRequestModal';
import FinalizeRequestModal from '../Modals/FinalizeRequestModal';
import CustomCloseButton from '../Components/CustomCloseButton';
import StatusSpinner from '../Components/StatusSpinner';

// import { jsPDF } from "jspdf";

import {inputMaxLengths} from '../HelperFunctions/InputMaxLengths';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlus, faCircleMinus } from '@fortawesome/free-solid-svg-icons';
import useNotification from '../Hooks/useNotification';

const Maintenance = () => {
  const { currentUser, showSpinner, setShowSpinner } = useAuth();
  const [newMaintenance, setNewMaintenance] = useState([]);
  const [createdWorkOrders, setCreatedWorkOrders] = useState([]);
  const [scheduledWorkOrders, setScheduledWorkOrders] = useState([]);
  const [completedWorkOrders, setCompletedWorkOrders] = useState([]);

  const [technicians, setTechnicians] = useState([]);
  
  const [modalShow, setModalShow] = useState(false);
  const [createModalShow, setCreateModalShow] = useState(false);
  const [finalizeModalShow, setFinalizeModalShow] = useState(false);
  const [chosenRequest, setChosenRequest] = useState({});
  const [currentWorkOrderHours, setCurrentWorkOrderHours] = useState([]);

  const [currentClientInfo, setCurrentClientInfo] = useState({});

  const [defaultRateInfo, setDefaultRateInfo] = useState({truckCharge: "0", dailyRates: {Monday: "0", Tuesday: "0", Wednesday:"0", Thursday:"0", Friday:"0", Saturday:"0", Sunday:"0"}});
  const [defaultTruckCharge, setDefaultTruckCharge] = useState("");
  const [defaultDailyRates, setDefaultDailyRates] = useState({Monday: "0", Tuesday: "0", Wednesday:"0", Thursday:"0", Friday:"0", Saturday:"0", Sunday:"0"});

  const [updateOrderButtonStatus, setUpdateOrderButtonStatus] = useState('edit');  // edit or save
  const [usageOverride, setUsageOverride] = useState(false);

  /**
   * status
   * 1 = request not turned into a work order yet (new request)
   * 2 = work order created (new request turned into a work order, ready to be assigned to a Technician and scheduled)
   * 3 = scheduled work order (work order assigned to a tech and schedule date given)
   * 4 = tech has completed work order (now ready for admin review)
   * 5 = work order reviewed and accepted (work order leaves dashboard but available in history)
  */
  useEffect(()=>{
    let unsubscribe = ()=>{console.log('default function while waiting')};
    if(updateOrderButtonStatus === 'edit'){
      setShowSpinner(true);
      const q = query(collection(db, "requests"), where("status", ">", 0), where("status", "<", 5));
      unsubscribe = onSnapshot(q, async (snapshot)=>{
        console.log('subscribe to snapshot');
        setShowSpinner(false);
        if(snapshot.size > 0){
          let tempNewMaintenance = [];
          let tempCreatedWorkOrders = [];
          let tempScheduledWorkOrders = [];
          let tempCompletedWorkOrders = [];
          snapshot.forEach((snap) =>{
            if(snap.data().type === 'maintenance'){
                switch(snap.data().status){
                case 1:
                    tempNewMaintenance = [...tempNewMaintenance, {data: snap.data(), id: snap.id}];
                    setNewMaintenance(tempNewMaintenance);
                    break;
                case 2:
                    tempCreatedWorkOrders = [...tempCreatedWorkOrders, {data: snap.data(), id: snap.id}];
                    setCreatedWorkOrders(tempCreatedWorkOrders);
                    break;
                case 3:
                    tempScheduledWorkOrders = [...tempScheduledWorkOrders, {data: snap.data(), id: snap.id}];
                    setScheduledWorkOrders(tempScheduledWorkOrders);
                    break;
                case 4:
                    tempCompletedWorkOrders = [...tempCompletedWorkOrders, {data: snap.data(), id: snap.id}];
                    setCompletedWorkOrders(tempCompletedWorkOrders);
                    break;
                default:
                    break;
                }
            }
          });
          if(tempNewMaintenance.length === 0){ setNewMaintenance([]) }
          if(tempCreatedWorkOrders.length === 0){ setCreatedWorkOrders([]) }
          if(tempScheduledWorkOrders.length === 0){ setScheduledWorkOrders([]) }
          if(tempCompletedWorkOrders.length === 0) { setCompletedWorkOrders([]) }
        }else{
          setNewMaintenance([]);
          setCreatedWorkOrders([]);
          setScheduledWorkOrders([]);
          setCompletedWorkOrders([]);
        }
      }, (error)=> {
        toast.error(`Failed to load data: ${error.message}`);
      });
    }else{
      console.log('modal popup unsubscribe to snapshot')
      unsubscribe();
    }

    return ()=>{
      console.log("unsubscribe to snapshot");
      unsubscribe();
    }
  }, [setShowSpinner, updateOrderButtonStatus]);

  useEffect(()=>{
    ///////////////// SINGLE SNAPSHOT LISTENER WHEN EDITING A WO
    let unsubscribe = ()=>{console.log('single unsubscribe place holder')}
    if(updateOrderButtonStatus === 'save'){
      setShowSpinner(true);
      unsubscribe = onSnapshot(doc(db, "requests", chosenRequest.id), (snap) => {
        console.log("Current data: ", snap.data());
        setShowSpinner(false);
        if(snap.exists){
          let tempNewMaintenance = [];
          let tempCreatedWorkOrders = [];
          let tempScheduledWorkOrders = [];
          let tempCompletedWorkOrders = [];
          // snapshot.forEach((snap) =>{
            switch(snap.data().status){
              case 1:
                tempNewMaintenance = [...tempNewMaintenance, {data: snap.data(), id: snap.id}];
                setNewMaintenance(tempNewMaintenance);
                break;
              case 2:
                tempCreatedWorkOrders = [...tempCreatedWorkOrders, {data: snap.data(), id: snap.id}];
                setCreatedWorkOrders(tempCreatedWorkOrders);
                break;
              case 3:
                tempScheduledWorkOrders = [...tempScheduledWorkOrders, {data: snap.data(), id: snap.id}];
                setScheduledWorkOrders(tempScheduledWorkOrders);
                break;
              case 4:
                tempCompletedWorkOrders = [...tempCompletedWorkOrders, {data: snap.data(), id: snap.id}];
                setCompletedWorkOrders(tempCompletedWorkOrders);
                break;
              default:
                break;
            }
          //});
          if(tempNewMaintenance.length === 0){ setNewMaintenance([]) }
          if(tempCreatedWorkOrders.length === 0){ setCreatedWorkOrders([]) }
          if(tempScheduledWorkOrders.length === 0){ setScheduledWorkOrders([]) }
          if(tempCompletedWorkOrders.length === 0) { setCompletedWorkOrders([]) }
        }else{
          setNewMaintenance([]);
          setCreatedWorkOrders([]);
          setScheduledWorkOrders([]);
          setCompletedWorkOrders([]);
        }
      }, (error)=>{
        toast.error(`Failed to load data: ${error.message}`);
      });
    }else{
      // setSingleListener({});
      unsubscribe();
    }
    return ()=>{
      console.log('single unsubscribe');
      unsubscribe();
    }
  },[chosenRequest, updateOrderButtonStatus, setShowSpinner]);

  useEffect(()=>{
    setShowSpinner(true);
    let tempTechnicians = [];
    const q = query(collection(db, "technicians"), where("access", "==", "technician"));
    getDocs(q).then((querySnapshot)=>{
      setShowSpinner(false);
      querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        tempTechnicians = [...tempTechnicians, {id: doc.id, data: doc.data()}];
      });
    }).then(()=>{
      setTechnicians(tempTechnicians);
    }).catch((error)=>{
      setShowSpinner(false);
      toast.error(`Failed to load data: ${error.message}`);
    });
    setShowSpinner(true);
    getDocs(collection(db, "rates")).then((snapShot)=>{
        let tempTruckCharge = "0";
        let tempDailyRates = {Monday: "0", Tuesday: "0", Wednesday:"0", Thursday:"0", Friday:"0", Saturday:"0", Sunday:"0"};
        snapShot.forEach((doc)=>{
            if(doc.id === 'truck'){
                tempTruckCharge = doc.data().rate;
            }
            if(doc.id === 'daily_tech_rates'){
                tempDailyRates = doc.data();
            }
        });
        return {truckCharge: tempTruckCharge, dailyRates: tempDailyRates};
    }).then((info)=>{
        setShowSpinner(false);
        setDefaultRateInfo(info);
        setDefaultTruckCharge(info.truckCharge);
        setDefaultDailyRates(info.dailyRates);
    }).catch((error)=>{
        setShowSpinner(false);
        toast.error(`Error getting rates list: ${error.message}`);
    });
  }, [setShowSpinner]);

  const loadHours = (requestID)=>{
    return new Promise(async (resolve, reject)=>{
      setShowSpinner(true);
      try{
        let hoursData = [];
        const q = query(collection(db, "hours"), where("requestID", "==", requestID));
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc)=>{
          hoursData = [...hoursData, doc.data()];
        });
        resolve(hoursData);
      }catch(error){
        reject(error.message);
      }
      setShowSpinner(false);
    });
  };

  const loadClientInfo = (client_id, client_location_id)=>{
    // load customer profile and location profile information once for use, only update if props changes
    // props?.request?.data?.client_id
    // props?.request?.data?.client_location_id
    return new Promise(async (resolve, reject)=>{
      if(client_id !== undefined && client_id !== "" && client_id !== null){
        setShowSpinner(true);
        try{
          const docRef = doc(db, "client_information", client_id);
          const docSnap = await getDoc(docRef)
          setShowSpinner(false);
          if(docSnap.exists()){
            let tempClientInfo = {...docSnap.data()}
            delete tempClientInfo.Locations;
            if(client_location_id !== undefined && client_location_id !== "" && client_location_id !== null){
              const locInfo = docSnap.data().Locations.filter(elem => elem.id === client_location_id);
              if(locInfo.length > 0){
                resolve({client_info: tempClientInfo, location_info: locInfo});
              }else{
                toast.info('Location no longer exists');
                resolve({client_info: tempClientInfo, location_info: []})
              }
            } else{
              toast.info('No linked location');
              resolve({client_info: tempClientInfo, location_info: []})
            }
            
          }else{
            toast.info(`Client no longer exists`);
            resolve({client_info: {}, location_info: []});
          }
        }catch(error){
          setShowSpinner(false);
          toast.error(`Failed to load client data: ${error.message}`);
          resolve({client_info: {}, location_info: []});
        }
      }else{
        toast.info('No linked Client Profile');
        resolve({client_info: {}, location_info: []});
      }
    });
    // will need to know if override is given as to not reoverride when modal loads again
    // maybe remove client database link or location database link
  };

  const RequestModal = (props) =>{
    // console.log(props.request.data)
    const [custName, setCustName] = useState(props?.request?.data?.work_order?.cust_auth_contact === undefined ? props?.request?.data?.["client name"] : props?.request?.data?.work_order?.cust_auth_contact);
    const [serviceAt, setServiceAt] = useState(props?.request?.data?.work_order?.service_at === undefined ? props?.request?.data?.address : props?.request?.data?.work_order?.service_at);
    const [custPhoneNo, setCustPhoneNo] = useState(props?.request?.data?.work_order?.phone_number === undefined ? props?.request?.data?.['phone number'] : props?.request?.data?.work_order?.phone_number);
    const [custEmail, setCustEmail] = useState(props?.request?.data?.work_order?.email_address === undefined ? props?.request?.data?.['email address'] : props?.request?.data?.work_order?.email_address);
    const [requestType, setRequestType] = useState(props?.request?.data?.work_order?.request_type === undefined ? props?.request?.data?.type : props?.request?.data?.work_order?.request_type);
    const [typeOfService, setTypeOfService] = useState(props?.request?.data?.work_order?.type_of_service === undefined ? props?.request?.data?.['type of service'] : props?.request?.data?.work_order?.type_of_service);
    const [requestDetails, setRequestDetails] = useState(props?.request?.data?.work_order?.details === undefined ? props?.request?.data?.details : props?.request?.data?.work_order?.details);
    const [workOrderNo, setWorkOrderNo] = useState(props?.request?.data?.work_order?.order_number === undefined ? '' : props?.request?.data?.work_order?.order_number);
    const [customer, setCustomer] = useState(props?.request?.data?.work_order?.customer === undefined ? '' : props?.request?.data?.work_order?.customer);
    const [customerPurchaseOrder, setCustomerPurchaseOrder] = useState(props?.request?.data?.work_order?.customer_purchase_order === undefined ? '' : props?.request?.data?.work_order?.customer_purchase_order);
    const [scheduledDate, setScheduledDate] = useState(props?.request?.data?.work_order?.scheduled_date === undefined ? "" : timestampToHTMLDateInput(props?.request?.data?.work_order?.scheduled_date));
    const [scheduledPriority, setScheduledPriority] =  useState(props?.request?.data?.work_order?.priority === undefined ? 10 : props?.request?.data?.work_order?.priority);
    const [assignedTechnicians, setAssignedTechnicians] = useState(props?.request?.data?.work_order?.assigned_techs === undefined ? [] : props?.request?.data?.work_order?.assigned_techs);
    const [leadTech, setLeadTech] = useState(props?.request?.data?.work_order?.lead_tech === undefined ? '' : props?.request?.data?.work_order?.lead_tech);
    const [units, setUnits] = useState(props?.request?.data?.work_order?.units === undefined ? [] : props?.request?.data?.work_order?.units);
    const [materials, setMaterials] = useState(props?.request?.data?.work_order?.materials === undefined ? [] : props?.request?.data?.work_order?.materials);

    //const [displayPrintOptions, setDisplayPrintOptions] = useState(false);
    const [displayConvertFields, setDisplayConvertFields] = useState(false);

    //const [printInvoiceNumber, setPrintInvoiceNumber] = useState(props?.request?.data?.print_invoice_number === undefined ? false : props?.request?.data?.print_invoice_number);
    const [printQuoteNumber, setPrintQuoteNumber] = useState(props?.request?.data?.print_quote_number === undefined ? null : props?.request?.data?.print_quote_number);
    const [printMaterials, setPrintMaterials] = useState(props?.request?.data?.print_materials === undefined ? null : props?.request?.data?.print_materials);
    const [printMaterialCharges, setPrintMaterialCharges] = useState(props?.request?.data?.print_material_charges === undefined ? null : props?.request?.data?.print_material_charges);
    const [printTruckCharge, setPrintTruckCharge] = useState(props?.request?.data?.print_truck_charge === undefined ? null : props?.request?.data?.print_truck_charge);
    const [printHours, setPrintHours] = useState(props?.request?.data?.print_hours === undefined ? null : props?.request?.data?.print_hours);

    // eslint-disable-next-line no-unused-vars
    const [workCompleted, setWorkCompleted] = useState(props?.request?.data?.status === undefined ? false : props.request.data.status > 3 ? true : false);
    // eslint-disable-next-line no-unused-vars
    const [dateCompleted, setDateCompleted] = useState(props?.request?.data?.complete_timestamp === undefined ? "" : timestampToHTMLDateInput(props.request.data.complete_timestamp));
    // eslint-disable-next-line no-unused-vars
    const [completeTimestamp, setCompleteTimestamp] = useState(props?.request?.data?.complete_timestamp === undefined ? null : props.request.data.complete_timestamp);
    const [truckCharge, setTruckCharge] = useState(
      props?.request?.data?.work_order?.truck_charge === undefined ? 
        currentClientInfo?.location_info !== undefined && currentClientInfo.location_info.length > 0 && currentClientInfo.location_info[0]["Truck Charge"] !== null ?
          currentClientInfo.location_info[0]["Truck Charge"]
        :
          currentClientInfo?.client_info?.["Truck Charge"] !== undefined && currentClientInfo.client_info["Truck Charge"] !== null ?
            currentClientInfo.client_info["Truck Charge"]
          :
            0.00
      :
        props.request.data.work_order.truck_charge
    );

    const [hours, setHours] = useState(props?.currentworkorderhours === undefined ?  [] : props.currentworkorderhours);

    const [quoteNo, setQuoteNo] = useState(props?.request?.data?.work_order?.quote_number === undefined ? '' : props?.request?.data?.work_order?.quote_number);
    const [quoteAmount, setQuoteAmount] = useState(props?.request?.data?.work_order?.quote_amount === undefined ||  props?.request?.data?.work_order?.quote_amount === "" ? 0.00 : props?.request?.data?.work_order?.quote_amount);

    const [techToAddHours, setTechToAddHours] = useState("");

    const [emailTooltip, setEmailTooltip] = useState('');

    const [convertRequestType, setConvertRequestType] = useState('service');
    const [convertTypeOfService, setConvertTypeOfService] = useState('');
    const [convertDetails, setConvertDetails] = useState('');

    const [ getConfirmation, NotificationModal ] = useNotification();

    const emailReg = /[A-Za-z0-9._+-]+@[A-Za-z0-9 -]+\.[a-z]{2,}/g;

    const toggleOrderButtonStatus = async ()=>{
      if(updateOrderButtonStatus === 'edit'){
        const requestRef = doc(db, "requests", props.request.id);
        runTransaction(db, async (transaction)=>{
          const requestDoc = await transaction.get(requestRef);
          if(!requestDoc.exists()){
            throw new Error("Request document does not exist");
          }
          const newState = {...requestDoc.data(),
            work_order: {
              ...requestDoc.data().work_order,
              used: {email: currentUser.email, timestamp: currentTimeStamp()},
            }
          };
          await transaction.update(requestRef, newState);
        }).then(()=>{
          props.request.data = {...props.request.data, 
            work_order: {
              ...props.request.data.work_order,
              used: {email: currentUser.email, timestamp: currentTimeStamp()},
            }
          };
          setShowSpinner(false);
          setUpdateOrderButtonStatus('save');
        }).catch((error)=>{
          setShowSpinner(false);
          console.log(error);
          toast.error(`Failed to save data: ${error.message}`);
        });
      }
      if(updateOrderButtonStatus === 'save'){
        if(emailTooltip !== ''){
          toast.error(`Email is not a valid format.`);
          return null;
        }
        let updatedStatus = props?.request?.data?.status > 0 ? props.request.data.status : 1;
        let saveToTechniciansProfile = false;
        
        // update status if work order is set
        if(workOrderNo !== "" || typeof HTMLDateInputToTimestamp(scheduledDate) !== 'number' || assignedTechnicians.length === 0){
          updatedStatus = 2;
        }
        // update status if work order, scheduled date and at least one technician is set
        if(workOrderNo !== "" && typeof HTMLDateInputToTimestamp(scheduledDate) === 'number' && assignedTechnicians.length > 0){
          if(workCompleted){
            updatedStatus = 4;
          }else{
            updatedStatus = 3;
          }
          saveToTechniciansProfile = true;
        }
        if(workOrderNo === ""){
          updatedStatus = 1;
        }
        // save work order to request id from state
        // props.request.data.status = updatedStatus;

        if(updatedStatus === 3){
          let notificationData = {tech: false, client: false};
          try{
            notificationData = await getConfirmation(custEmail);
          }catch(err){
            console.log(err);
          }
          saveByTransaction(updatedStatus, saveToTechniciansProfile, notificationData);
        }else{
          saveByTransaction(updatedStatus, saveToTechniciansProfile);
        }        
      }
    };

    const saveByTransaction = (updatedStatus, saveToTechniciansProfile, notificationData = {tech: false, client: false})=>{
        // run a transaction on specific request, each tech
        // first load specific request, and each tech if applicable (loading them first will protect against changes)
        // update request and each tech if applicable
        // pass out work_order object and update request state (props.request.data) - as shown above
        setShowSpinner(true);
        const requestRef = doc(db, "requests", props.request.id);
        runTransaction(db, async (transaction)=>{
          const requestDoc = await transaction.get(requestRef);
          if(!requestDoc.exists()){
            throw new Error("Request document does not exist");
          }
          let oldAssignedTechIds = [];
          if(requestDoc?.data()?.work_order?.assigned_techs !== undefined){
            oldAssignedTechIds = requestDoc.data().work_order.assigned_techs;
          }
          let techDocs = [];
          for(let x=0; x < assignedTechnicians.length; ++x){
            techDocs[x] = await transaction.get(doc(db, "technicians", assignedTechnicians[x]));
            if(!techDocs[x].exists()){
              throw new Error("Technician document does not exist");
            }
          }
          let removeTechDocs = [];
          for(let x=0; x<oldAssignedTechIds.length; ++x){
            if(!assignedTechnicians.includes(oldAssignedTechIds[x]) || updatedStatus === 1 || updatedStatus === 2){
              const info = await transaction.get(doc(db, "technicians", oldAssignedTechIds[x]));
              removeTechDocs.push(info);
            }
          }
          let updateHourDocs = [];
          let addHourDocs = [];
          let removeHourDocs = []
          // console.log(hours);
          for(let x=0; x<hours.length; ++x){
            const updateDocInfo = await transaction.get(doc(db, "hours", `${props.request.id}_${hours[x].techID}`));
            if(updateDocInfo.exists()){
              updateHourDocs.push(hours[x]);
            }else{
              addHourDocs.push(hours[x]);
            }
          }

          for(let x=0; x<currentWorkOrderHours.length; ++x){
            if(!hours.find(tech => {
                if(tech.techID === currentWorkOrderHours[x].techID){
                  return true; 
                }
                return false; // add to be deleted, cannot be found
              })){
                removeHourDocs.push(currentWorkOrderHours[x]);
            }
          }

          for(let x=0; x<updateHourDocs.length; ++x){
            await transaction.update(doc(db, "hours", `${updateHourDocs[x].requestID}_${updateHourDocs[x].techID}`), updateHourDocs[x]);
          }

          for(let x=0; x<addHourDocs.length; ++x){
            await transaction.set(doc(db, "hours", `${addHourDocs[x].requestID}_${addHourDocs[x].techID}`), addHourDocs[x]);
          }

          for(let x=0; x<removeHourDocs.length; ++x){
            await transaction.delete(doc(db, "hours", `${removeHourDocs[x].requestID}_${removeHourDocs[x].techID}`));
          }
          const newHoursState = hours;
          const newState = {...requestDoc.data(),
            complete_timestamp: updatedStatus < 4 ? null : completeTimestamp,
            work_order: {
              cust_auth_contact: custName,
              service_at: serviceAt,
              phone_number: custPhoneNo,
              email_address: custEmail,
              request_type: requestType,
              type_of_service: typeOfService,
              details: requestDetails,
              order_number: workOrderNo,
              customer: customer,
              customer_purchase_order: customerPurchaseOrder,
              scheduled_date: HTMLDateInputToTimestamp(scheduledDate),
              priority: parseInt(scheduledPriority),
              lead_tech: leadTech,
              assigned_techs: assignedTechnicians,
              units: units,
              materials: materials,
              // hours: hours,
              truck_charge: truckCharge !== "" ? parseFloat(truckCharge) : 0,
              last_saved: {by: currentUser.email, at: currentTimeStamp()},
              used: {email: "", timestamp: ""},
              quote_number: quoteNo,
              quote_amount: quoteAmount,
            }
          };
          newState.status = updatedStatus;
          await transaction.update(requestRef, newState);

          if(saveToTechniciansProfile){
            for(let x=0; x < techDocs.length; ++x){
              let newTechDoc = techDocs[x].data();
              const indexOfId = newTechDoc.work_orders.findIndex(e => e.id === requestDoc.id);
              if(indexOfId > -1){
                newTechDoc.work_orders[indexOfId] = {
                  id: requestDoc.id,
                  address: serviceAt,
                  work_order_number: workOrderNo,
                  priority: parseInt(scheduledPriority),
                  timestamp: HTMLDateInputToTimestamp(scheduledDate),
                  status: updatedStatus,
                  complete_timestamp: updatedStatus < 4 ? null : completeTimestamp,
                }
              }else{
                newTechDoc.work_orders.push({
                  id: requestDoc.id,
                  address: serviceAt,
                  work_order_number: workOrderNo,
                  priority: parseInt(scheduledPriority),
                  timestamp: HTMLDateInputToTimestamp(scheduledDate),
                  status: updatedStatus,
                  complete_timestamp: updatedStatus < 4 ? null : completeTimestamp,
                });
              }
              await transaction.update(doc(db, "technicians", techDocs[x].id), newTechDoc);
            }
          }
          // remove if de-selected the tech
          for(let x=0; x<removeTechDocs.length; ++x){
            let newTechDoc = removeTechDocs[x].data();
            // console.log(newTechDoc);
            const indexOfId = newTechDoc.work_orders.findIndex(e => e.id === requestDoc.id);
            if(indexOfId > -1){
              newTechDoc.work_orders.splice(indexOfId, 1);
            }// if doesn't exist then don't need to remove
            await transaction.update(doc(db, "technicians", removeTechDocs[x].id), newTechDoc);
          }

          return {newState: newState, newHoursState: newHoursState, techs: techDocs};
        }).then((states)=>{
          // update state of props.request.data
          // set props
          props.request.data = {...props.request.data, 
            work_order: {
              cust_auth_contact: custName,
              service_at: serviceAt,
              phone_number: custPhoneNo,
              email_address: custEmail,
              request_type: requestType,
              type_of_service: typeOfService,
              details: requestDetails,
              order_number: workOrderNo,
              customer: customer,
              customer_purchase_order: customerPurchaseOrder,
              scheduled_date: HTMLDateInputToTimestamp(scheduledDate),
              priority: parseInt(scheduledPriority),
              lead_tech: leadTech,
              assigned_techs: assignedTechnicians,
              units: units,
              materials: materials,
              // hours: hours,
              truck_charge: truckCharge !== "" ? parseFloat(truckCharge) : 0,
              last_saved: {by: currentUser.email, at: currentTimeStamp()},
              used: {email: "", timestamp: ""},
              quote_number: quoteNo,
              quote_amount: quoteAmount,
            }
          };
          props.request.data.status = updatedStatus;

          setCurrentWorkOrderHours(states.newHoursState);
          setHours(states.newHoursState);
          return states.techs
        }).then((techDocs)=>{
          setShowSpinner(false);
          setUpdateOrderButtonStatus('edit');
          toast.success(`Successfully updated work order: ${workOrderNo}`);
          const functions = getFunctions();
          if(notificationData.tech){
            console.log('send Technician notification');
            let tokens = [];
            console.log('SEND NOTIFICATION - STATUS 3 DISPATCHED');
            techDocs.forEach((tech)=>{
                let activeFCMToken = false;
                let FCMPermission = false;
                if(tech.data()?.fcm_token !== undefined && tech.data().fcm_token !== ""){
                  activeFCMToken = true;
                }
                if(tech.data()?.fcm_is_authorized !== undefined && tech.data().fcm_is_authorized){
                  FCMPermission = true;
                }
                if(activeFCMToken && FCMPermission){
                  tokens.push(tech.data().fcm_token);
                }
            });
            if(tokens.length > 0){
                const sendNotification = httpsCallable(functions, 'sendNotification');
                sendNotification({
                  wo_number: workOrderNo,
                  date_dispatched: scheduledDate,
                  tokens: tokens
                }).then((response)=>{
                  console.log(response.data.status);
                  if(response.data.status === "200"){
                      console.log(response.data.info);
                      console.log(`success count: ${response.data.success_count}`);
                      console.log(`failure count: ${response.data.failure_count}`);
                  }else{
                      console.log(response.data.info);
                  }
                }).catch((error)=>{
                    toast.error('There was an error sending Notifications');
                });
            }
          }
          if(notificationData.client && custEmail !== ""){
            //CUST. AUTHORIZATION/CONTACT EMAIL ADDRESS:
            const sendDispatchNote = httpsCallable(functions, 'sendDispatchNote');
            sendDispatchNote({
              "type": requestType,
              "type of service": typeOfService,
              "email address": custEmail,
              "client name": custName,
              "address": serviceAt,
              "details": requestDetails,
              "phone number": custPhoneNo,
              "scheduled_date": scheduledDate,
              "order_number": workOrderNo,
              "docId": props.request.id
            }).then((response)=>{
              console.log(response.data.status);
              if(response.data.status === "200"){
                  console.log(response.data.messageId);
              }else{
                  console.log(response.data.message);
              }
            }).catch((error)=>{
                console.log('There was an error sending Dispatch Note: ' + error)
                toast.error('There was an error sending Dispatch Note: ' + error);
            });
          }
          // props.onHide('no cancel');
        }).catch((error)=>{
          setShowSpinner(false);
          console.log(error);
          toast.error(`Failed to save data: ${error.message}`);
        });
    };
    const updateAssignedTechnicians = (event)=>{
      // console.log(event.target.selectedOptions)
      setAssignedTechnicians([].slice.call(event.target.selectedOptions).map(item => item.value));
      if(event.target.selectedOptions.length === 0){
        setLeadTech('');
        return null;
      }
      if(event.target.selectedOptions.length === 1){
        setLeadTech(event.target.selectedOptions[0].value);
        return null;
      }
      if(![].slice.call(event.target.selectedOptions).find(tech => tech.value === leadTech)){
        setLeadTech([].slice.call(event.target.selectedOptions)[0].value);
        return null;
      }
    };
    const addUnits = () => {
      const COOLING_DESCRIPTION = `- INSPECTED COILS, CLEANED P-TRAPS\n- CHECKED REFRIDGERANT LEVELS\n- INSPECTED & CHANGED DIRTY FILTERS\n- REPLACED, ADJUSTED BELTS AS NECESSARY\n- CHECKED COOLING OPERATION, ELECTRICAL & MECHANICAL ALSO\n- INSPECTED & LUBRICATED MECHANICAL COMPONENTS AS NECESSARY`;
      const COOLING_RECOMMENDED = `FOR INDIVIDUAL UNIT FINDINGS, PLEASE REFER TO PM FIELD REPORT`;

      const HEATING_DESCRIPTION = `- INSPECTED HEAT EXCHANGERS\n- CHECKED HEATING OPERATION, ELECTRICAL & MECHANICAL\n- CHANGED SOILED AIR FILTERS\n- CHANGED, ADJUSTED BELTS AS NECESSARY\n- LUBRICATED MECHANICAL COMPONENTS AS REQUIRED\n- CHECKED HIGH LIMIT & ROLLOUT SAFETIES\n- CHECKED ALL ELECTRICAL CONNECTIONS, WIRING & SAFETIES`;
      const HEATING_RECOMMENDED = `FOR INDIVIDUAL UNIT FINDINGS, PLEASE REFER TO PM FIELD REPORT`;

      let desc_of_work_performed_string = '';
      let service_recommended_string = '';
      if(typeOfService === 'Cooling'){
        desc_of_work_performed_string = COOLING_DESCRIPTION;
        service_recommended_string = COOLING_RECOMMENDED;
      }
      if(typeOfService === 'Heating'){
        desc_of_work_performed_string = HEATING_DESCRIPTION;
        service_recommended_string = HEATING_RECOMMENDED;
      }

      let tempUnits = [...units];
      tempUnits.unshift({
        Make: '',
        Model: '',
        Serial: '',
        'Description of Work Performed': desc_of_work_performed_string,
        'Service Recommended': service_recommended_string,
      });
      setUnits(tempUnits);
    };
    const removeUnits = (index) => {
      let tempUnits = [...units];
      tempUnits.splice(index, 1);
      setUnits(tempUnits);
    };
  
    const updateUnits = (unit, field, value)=>{
      let tempUnits = [...units];
      let tempUnit = {
        ...tempUnits[unit],
        [field]: value,
      };
      tempUnits[unit] = tempUnit;
      setUnits(tempUnits);
    };
    const addMaterials = () => {
      let tempMaterials = [...materials];
      tempMaterials.unshift({Source: '', Qty: '', 'Material Description': '', 'Price': ''});
      setMaterials(tempMaterials);
    };
    const removeMaterials = (index) => {
      let tempMaterials = [...materials];
      tempMaterials.splice(index, 1);
      setMaterials(tempMaterials);
    };
    const updateMaterials = (material, field, value)=>{
      let tempMaterials = [...materials];
      let tempMaterial = {
        ...tempMaterials[material],
        [field]: value,
      };
      tempMaterials[material] = tempMaterial;
      setMaterials(tempMaterials);
    };
    const addHours = ()=>{
      // later update setCurrentWorkOrderHours on the maint screen after saving
      console.log(hours)
      let tempHours = [...hours];
      tempHours.push({
        Monday: "",
        Tuesday: "",
        Wednesday: "",
        Thursday: "",
        Friday: "",
        Saturday: "",
        Sunday: "",
        Premium_Monday: "",
        Premium_Tuesday: "",
        Premium_Wednesday: "",
        Premium_Thursday: "",
        Premium_Friday: "",
        Premium_Saturday: "",
        Premium_Sunday: "",
        'Premium Monday Rate': "",
        'Premium Tuesday Rate': "",
        'Premium Wednesday Rate': "",
        'Premium Thursday Rate': "",
        'Premium Friday Rate': "",
        'Premium Saturday Rate': "",
        'Premium Sunday Rate': "",
        'Monday Rate': "",
        'Tuesday Rate': "",
        'Wednesday Rate': "",
        'Thursday Rate': "",
        'Friday Rate': "",
        'Saturday Rate': "",
        'Sunday Rate': "",
        order_number: workOrderNo,
        requestID: props.request.id,
        techID: techToAddHours,
        last_saved: {
          at: currentTimeStamp(),
          by: currentUser.email,
        },
      });
      // console.log(tempHours);
      setHours(tempHours);
    };
    const removeHours = (index)=>{
      let tempHours = [...hours];
      tempHours.splice(index, 1);
      setHours(tempHours);
    };
    const updateTechHours = (index, field, value)=> {
      let tempHours = [...hours];
      tempHours[index] = {...hours[index],
        [field]: value,
      };
      setHours(tempHours);
    };

    const loadCustomerRateHours = (index)=>{
      // if location hourly rate is valid
      if((currentClientInfo?.location_info[0]?.["Hourly Rate"] !== "") && (currentClientInfo?.location_info[0]?.["Hourly Rate"] !== undefined ) && (currentClientInfo?.location_info[0]?.["Hourly Rate"] !== null)){
        let tempHours = [...hours];
        // if location hourly rate and location premium hours valid
        if(currentClientInfo?.location_info[0]?.["Premium Hours Rate"] !== "" && currentClientInfo?.location_info[0]?.["Premium Hours Rate"] !== undefined && currentClientInfo?.location_info[0]?.["Premium Hours Rate"] !== null){
          tempHours[index] = {...hours[index],
            'Monday Rate': currentClientInfo?.location_info[0]?.["Hourly Rate"],
            'Tuesday Rate': currentClientInfo?.location_info[0]?.["Hourly Rate"],
            'Wednesday Rate': currentClientInfo?.location_info[0]?.["Hourly Rate"],
            'Thursday Rate': currentClientInfo?.location_info[0]?.["Hourly Rate"],
            'Friday Rate': currentClientInfo?.location_info[0]?.["Hourly Rate"],
            'Saturday Rate': currentClientInfo?.location_info[0]?.["Hourly Rate"],
            'Sunday Rate': currentClientInfo?.location_info[0]?.["Hourly Rate"],
            'Premium Monday Rate': currentClientInfo?.location_info[0]?.["Premium Hours Rate"],
            'Premium Tuesday Rate': currentClientInfo?.location_info[0]?.["Premium Hours Rate"],
            'Premium Wednesday Rate': currentClientInfo?.location_info[0]?.["Premium Hours Rate"],
            'Premium Thursday Rate': currentClientInfo?.location_info[0]?.["Premium Hours Rate"],
            'Premium Friday Rate': currentClientInfo?.location_info[0]?.["Premium Hours Rate"],
            'Premium Saturday Rate': currentClientInfo?.location_info[0]?.["Premium Hours Rate"],
            'Premium Sunday Rate': currentClientInfo?.location_info[0]?.["Premium Hours Rate"],
          };
          setHours(tempHours);
          // if location hourly rate and customer premium hours valid
        } else if(currentClientInfo?.client_info?.["Premium Hours"] !== "" && currentClientInfo?.client_info?.["Premium Hours"] !== undefined && currentClientInfo?.client_info?.["Premium Hours"] !== null){
          tempHours[index] = {...hours[index],
            'Monday Rate': currentClientInfo?.location_info[0]?.["Hourly Rate"],
            'Tuesday Rate': currentClientInfo?.location_info[0]?.["Hourly Rate"],
            'Wednesday Rate': currentClientInfo?.location_info[0]?.["Hourly Rate"],
            'Thursday Rate': currentClientInfo?.location_info[0]?.["Hourly Rate"],
            'Friday Rate': currentClientInfo?.location_info[0]?.["Hourly Rate"],
            'Saturday Rate': currentClientInfo?.location_info[0]?.["Hourly Rate"],
            'Sunday Rate': currentClientInfo?.location_info[0]?.["Hourly Rate"],
            'Premium Monday Rate': currentClientInfo?.client_info?.["Premium Hours"],
            'Premium Tuesday Rate': currentClientInfo?.client_info?.["Premium Hours"],
            'Premium Wednesday Rate': currentClientInfo?.client_info?.["Premium Hours"],
            'Premium Thursday Rate': currentClientInfo?.client_info?.["Premium Hours"],
            'Premium Friday Rate': currentClientInfo?.client_info?.["Premium Hours"],
            'Premium Saturday Rate': currentClientInfo?.client_info?.["Premium Hours"],
            'Premium Sunday Rate': currentClientInfo?.client_info?.["Premium Hours"],
          };
          setHours(tempHours);
          // if location hourly rate valid, but no premium hours valid
        } else {
          tempHours[index] = {...hours[index],
            'Monday Rate': currentClientInfo?.location_info[0]?.["Hourly Rate"],
            'Tuesday Rate': currentClientInfo?.location_info[0]?.["Hourly Rate"],
            'Wednesday Rate': currentClientInfo?.location_info[0]?.["Hourly Rate"],
            'Thursday Rate': currentClientInfo?.location_info[0]?.["Hourly Rate"],
            'Friday Rate': currentClientInfo?.location_info[0]?.["Hourly Rate"],
            'Saturday Rate': currentClientInfo?.location_info[0]?.["Hourly Rate"],
            'Sunday Rate': currentClientInfo?.location_info[0]?.["Hourly Rate"],
            'Premium Monday Rate': "",
            'Premium Tuesday Rate': "",
            'Premium Wednesday Rate': "",
            'Premium Thursday Rate': "",
            'Premium Friday Rate': "",
            'Premium Saturday Rate': "",
            'Premium Sunday Rate': "",
          };
          setHours(tempHours);
        }
        // if customer hourly rate valid
      } else if((currentClientInfo?.client_info?.["Hourly Rate"] !== "") && (currentClientInfo?.client_info?.["Hourly Rate"] !== undefined)  && (currentClientInfo?.client_info?.["Hourly Rate"] !== null)){
        let tempHours = [...hours];
        // if customer houlry rate valid and location premium hours valid
        if(currentClientInfo?.location_info[0]?.["Premium Hours Rate"] !== "" && currentClientInfo?.location_info[0]?.["Premium Hours Rate"] !== undefined && currentClientInfo?.location_info[0]?.["Premium Hours Rate"] !== null){
          tempHours[index] = {...hours[index],
            'Monday Rate': currentClientInfo?.client_info?.["Hourly Rate"],
            'Tuesday Rate': currentClientInfo?.client_info?.["Hourly Rate"],
            'Wednesday Rate': currentClientInfo?.client_info?.["Hourly Rate"],
            'Thursday Rate': currentClientInfo?.client_info?.["Hourly Rate"],
            'Friday Rate': currentClientInfo?.client_info?.["Hourly Rate"],
            'Saturday Rate': currentClientInfo?.client_info?.["Hourly Rate"],
            'Sunday Rate': currentClientInfo?.client_info?.["Hourly Rate"],
            'Premium Monday Rate': currentClientInfo?.location_info[0]?.["Premium Hours Rate"],
            'Premium Tuesday Rate': currentClientInfo?.location_info[0]?.["Premium Hours Rate"],
            'Premium Wednesday Rate': currentClientInfo?.location_info[0]?.["Premium Hours Rate"],
            'Premium Thursday Rate': currentClientInfo?.location_info[0]?.["Premium Hours Rate"],
            'Premium Friday Rate': currentClientInfo?.location_info[0]?.["Premium Hours Rate"],
            'Premium Saturday Rate': currentClientInfo?.location_info[0]?.["Premium Hours Rate"],
            'Premium Sunday Rate': currentClientInfo?.location_info[0]?.["Premium Hours Rate"],
          };
          setHours(tempHours);
          // if customer houlry rate valid and customer premium hours valid
        } else if(currentClientInfo?.client_info?.["Premium Hours"] !== "" && currentClientInfo?.client_info?.["Premium Hours"] !== undefined && currentClientInfo?.client_info?.["Premium Hours"] !== null){
          tempHours[index] = {...hours[index],
            'Monday Rate': currentClientInfo?.client_info?.["Hourly Rate"],
            'Tuesday Rate': currentClientInfo?.client_info?.["Hourly Rate"],
            'Wednesday Rate': currentClientInfo?.client_info?.["Hourly Rate"],
            'Thursday Rate': currentClientInfo?.client_info?.["Hourly Rate"],
            'Friday Rate': currentClientInfo?.client_info?.["Hourly Rate"],
            'Saturday Rate': currentClientInfo?.client_info?.["Hourly Rate"],
            'Sunday Rate': currentClientInfo?.client_info?.["Hourly Rate"],
            'Premium Monday Rate': currentClientInfo?.client_info?.["Premium Hours"],
            'Premium Tuesday Rate': currentClientInfo?.client_info?.["Premium Hours"],
            'Premium Wednesday Rate': currentClientInfo?.client_info?.["Premium Hours"],
            'Premium Thursday Rate': currentClientInfo?.client_info?.["Premium Hours"],
            'Premium Friday Rate': currentClientInfo?.client_info?.["Premium Hours"],
            'Premium Saturday Rate': currentClientInfo?.client_info?.["Premium Hours"],
            'Premium Sunday Rate': currentClientInfo?.client_info?.["Premium Hours"],
          };
          setHours(tempHours);
          // if customer houlry rate valid but no premium hours valid
        } else{
          tempHours[index] = {...hours[index],
            'Monday Rate': currentClientInfo?.client_info?.["Hourly Rate"],
            'Tuesday Rate': currentClientInfo?.client_info?.["Hourly Rate"],
            'Wednesday Rate': currentClientInfo?.client_info?.["Hourly Rate"],
            'Thursday Rate': currentClientInfo?.client_info?.["Hourly Rate"],
            'Friday Rate': currentClientInfo?.client_info?.["Hourly Rate"],
            'Saturday Rate': currentClientInfo?.client_info?.["Hourly Rate"],
            'Sunday Rate': currentClientInfo?.client_info?.["Hourly Rate"],
            'Premium Monday Rate': "",
            'Premium Tuesday Rate': "",
            'Premium Wednesday Rate': "",
            'Premium Thursday Rate': "",
            'Premium Friday Rate': "",
            'Premium Saturday Rate': "",
            'Premium Sunday Rate': "",
          };
          setHours(tempHours)
        }
        // if no location or customer hours are valid
      } else {
        let tempHours = [...hours];
        // if location premium hours are valid
        if(currentClientInfo?.location_info[0]?.["Premium Hours Rate"] !== "" && currentClientInfo?.location_info[0]?.["Premium Hours Rate"] !== undefined && currentClientInfo?.location_info[0]?.["Premium Hours Rate"] !== null){
          tempHours[index] = {...hours[index],
            'Monday Rate': "",
            'Tuesday Rate': "",
            'Wednesday Rate': "",
            'Thursday Rate': "",
            'Friday Rate': "",
            'Saturday Rate': "",
            'Sunday Rate': "",
            'Premium Monday Rate': currentClientInfo?.location_info[0]?.["Premium Hours Rate"],
            'Premium Tuesday Rate': currentClientInfo?.location_info[0]?.["Premium Hours Rate"],
            'Premium Wednesday Rate': currentClientInfo?.location_info[0]?.["Premium Hours Rate"],
            'Premium Thursday Rate': currentClientInfo?.location_info[0]?.["Premium Hours Rate"],
            'Premium Friday Rate': currentClientInfo?.location_info[0]?.["Premium Hours Rate"],
            'Premium Saturday Rate': currentClientInfo?.location_info[0]?.["Premium Hours Rate"],
            'Premium Sunday Rate': currentClientInfo?.location_info[0]?.["Premium Hours Rate"],
          };
          setHours(tempHours);
        // if customer premium hours are valid
        } else if(currentClientInfo?.client_info?.["Premium Hours"] !== "" && currentClientInfo?.client_info?.["Premium Hours"] !== undefined && currentClientInfo?.client_info?.["Premium Hours"] !== null){
          tempHours[index] = {...hours[index],
            'Monday Rate': "",
            'Tuesday Rate': "",
            'Wednesday Rate': "",
            'Thursday Rate': "",
            'Friday Rate': "",
            'Saturday Rate': "",
            'Sunday Rate': "",
            'Premium Monday Rate': currentClientInfo?.client_info?.["Premium Hours"],
            'Premium Tuesday Rate': currentClientInfo?.client_info?.["Premium Hours"],
            'Premium Wednesday Rate': currentClientInfo?.client_info?.["Premium Hours"],
            'Premium Thursday Rate': currentClientInfo?.client_info?.["Premium Hours"],
            'Premium Friday Rate': currentClientInfo?.client_info?.["Premium Hours"],
            'Premium Saturday Rate': currentClientInfo?.client_info?.["Premium Hours"],
            'Premium Sunday Rate': currentClientInfo?.client_info?.["Premium Hours"],
          };
          setHours(tempHours);
        // if no hours are valid
        } else {
          tempHours[index] = {...hours[index],
            'Monday Rate': "",
            'Tuesday Rate': "",
            'Wednesday Rate': "",
            'Thursday Rate': "",
            'Friday Rate': "",
            'Saturday Rate': "",
            'Sunday Rate': "",
            'Premium Monday Rate': "",
            'Premium Tuesday Rate': "",
            'Premium Wednesday Rate': "",
            'Premium Thursday Rate': "",
            'Premium Friday Rate': "",
            'Premium Saturday Rate': "",
            'Premium Sunday Rate': "",
          };
          setHours(tempHours);
        }

      }
    };

    const updateTechRateHours = (index, defaultHoursObject)=>{
      let tempHours = [...hours];
      tempHours[index] = {...hours[index],
        'Monday Rate': defaultHoursObject?.Monday,
        'Tuesday Rate': defaultHoursObject?.Tuesday,
        'Wednesday Rate': defaultHoursObject?.Wednesday,
        'Thursday Rate': defaultHoursObject?.Thursday,
        'Friday Rate': defaultHoursObject?.Friday,
        'Saturday Rate': defaultHoursObject?.Saturday,
        'Sunday Rate': defaultHoursObject?.Sunday,
      };
      setHours(tempHours);
    };

    const deleteWorkOrder = (requestID)=>{
      if(requestID === undefined){
        return null;
      }
      setShowSpinner(true);
      const requestRef = doc(db, "requests", requestID);
      runTransaction(db, async (transaction)=>{
        // load, save new, delete
        const requestDoc = await transaction.get(requestRef);
        if(!requestDoc.exists()){
          throw new Error("Request document does not exist");
        }
        await transaction.set(doc(db, 'deleted_work_orders/', requestDoc.id), {
          ...requestDoc.data(),
          work_order: {
            ...requestDoc.data().work_order,
            assigned_techs: [],
          }
        });
        await transaction.delete(requestRef);

        return requestDoc.data();
      }).then((newState)=>{
        // clean up
        setShowSpinner(false);
        console.log(newState);
        toast.success(`Work order has been deleted`);
        
        props.onHide('none', 'none');
      }).catch((error)=>{
          setShowSpinner(false);
        
          props.onHide('show cancel', 'none');
          toast.error(`Failed to save data: ${error.message}`);
      });
    };

    const convertToServiceRequest = (requestID)=>{
      if(requestID === undefined){
        return null;
      }
      setShowSpinner(true);
      const requestRef = doc(db, "requests", requestID);
      runTransaction(db, async (transaction)=>{
        // load, save new, delete
        const requestDoc = await transaction.get(requestRef);
        if(!requestDoc.exists()){
          throw new Error("Request document does not exist");
        }
        let tempData = {
          ...requestDoc.data(),
          details: convertDetails,
          type: convertRequestType,
          'type of service': convertRequestType === 'quote' ? 'not applicable - Quote' : convertTypeOfService,
        };

        if(tempData?.work_order?.details !== undefined && tempData?.work_order?.request_type !== undefined && tempData?.work_order?.type_of_service !== undefined){
          tempData = {
            ...tempData,
            work_order: {
              ...tempData.work_order,
              details: convertDetails,
              request_type: convertRequestType,
              type_of_service: convertRequestType === 'quote' ? 'not applicable - Quote' : convertTypeOfService,
            }
          }
        }
        transaction.update(requestRef, tempData);

        return requestDoc.data();
      }).then((newState)=>{
        // clean up
        setShowSpinner(false);
        console.log(newState);
        toast.success(`Work order has been converted to a Maintenance W.O.`);
        
        props.onHide('none', 'none');
      }).catch((error)=>{
          setShowSpinner(false);
        
          props.onHide('show cancel', 'none');
          toast.error(`Failed to convert work order: ${error.message}`);
      });
      // alert(`
      //   run transaction to convert to a maintenance order.
      //   requestID: ${requestID},
      //   New Request Type: ${convertRequestType},
      //   New Type of Service: ${convertTypeOfService},
      //   New Details: ${convertDetails}
      // `);
    };

    return(
      <Modal
        {...props}
        size="xl"
        // fullscreen
        animation={false}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>{props?.request?.data?.type.toUpperCase()}: {props?.request?.data?.work_order?.service_at === undefined ? props?.request?.data?.address : props?.request.data.work_order.service_at} - {props?.request?.data?.work_order?.order_number === undefined ? props?.request?.data?.["client name"] : props?.request?.data?.work_order?.order_number === '' ? props?.request?.data?.["client name"] : props?.request?.data?.work_order?.order_number}</Modal.Title>
          <div onClick={()=>{props.onHide('show cancel', props.request.id)}}><CustomCloseButton /></div>
        </Modal.Header>
        <Modal.Body>
          <Container fluid style={{marginTop:"20px"}}>
            <NotificationModal custEmail={custEmail} />
            <Row>
              <Col lg="6" style={{border:"1px solid black", padding:"10px", borderRadius:"10px", marginBottom:"5px"}}>
                <Row style={{marginBottom: "20px"}}><Col>GENERAL INFORMATION</Col></Row>
                <Row style={{marginLeft: "20px", marginTop:"10px"}}>
                    <Col>
                        Status: 
                        {props?.request?.data?.status === 1 && ' NEW REQUEST'}
                        {props?.request?.data?.status === 2 && ' CREATED WORK ORDER'}
                        {props?.request?.data?.status === 3 && ' SCHEDULED WORK ORDER'}
                        {props?.request?.data?.status === 4 && ' COMPLETED WORK ORDER'}
                    </Col>
                </Row>
                <Row style={{marginLeft: "20px", marginTop:"10px"}}>
                    <Col>
                        Next Steps: 
                        {props?.request?.data?.status === 1 && ' REVIEW REQUEST, SET WORK ORDER NUMBER'}
                        {props?.request?.data?.status === 2 && ' ASSIGN TECHS, SET PRIORITY, SET DISPATCH DATE'}
                        {props?.request?.data?.status === 3 && ' COORDINATE WITH TECHNICIAN'}
                        {props?.request?.data?.status === 4 && ' REVIEW, UPDATE CHARGES, FINALIZE WORK ORDER'}
                    </Col>
                </Row>
                <Row style={{marginLeft: "20px", marginTop:"10px", width:"400px"}}><Col>Service At:</Col><Col><a href={`https://www.google.com/maps/place/${serviceAt}`} target="_blank" rel="noreferrer">View Map</a></Col></Row>
                <Row style={{marginLeft: "20px", marginTop:"10px", width:"400px"}}><Col>Client Database Link:</Col><Col>{props?.request?.data?.client_id === undefined  || props?.request?.data?.client_id === "" ? 'Not Linked' : `${props.request.data.client_id}`}</Col></Row>
                <Row style={{marginLeft: "20px", marginTop:"10px", width:"400px"}}><Col>Location Database Link:</Col><Col>{props?.request?.data?.client_location_id === undefined  || props?.request?.data?.client_location_id === "" ? 'Not Linked' : `${props.request.data.client_location_id}`}</Col></Row>
              </Col>
              <Col lg="6" style={{border:"1px solid black", padding:"10px", borderRadius:"10px", marginBottom:"5px"}}>
                <Row style={{marginBottom: "20px"}}><Col>ACTION BUTTONS</Col></Row>
                <Row>
                  <Col lg="4">
                    <Button
                      className="btn-dark"
                      style={{backgroundColor:"#2596be", margin:5}}
                      onClick={()=>{
                        toggleOrderButtonStatus();
                      }}
                      >
                      {
                        updateOrderButtonStatus === 'edit' ? ("Edit Work Order") : ("Save Work Order") 
                      }
                    </Button>
                  </Col>
                  <Col lg="8">
                    {
                      updateOrderButtonStatus === 'save' ?
                        <Button
                          className="btn-dark"
                          style={{backgroundColor:"#2596be", margin:5}}
                          onClick={()=>{
                            setUpdateOrderButtonStatus('edit');
                            props.onHide('show cancel', props.request.id);
                          }}
                        >
                          Cancel
                        </Button>
                      :
                          <div></div>
                  }
                  {
                    (props?.request?.data?.status === 1 || props?.request?.data?.status === 2) && updateOrderButtonStatus === 'edit' &&
                      
                          <Button
                            className="btn-dark"
                            style={{backgroundColor:"#2596be", margin:5}}
                            onClick={()=>{
                                setDisplayConvertFields(!displayConvertFields)
                            }}
                          >
                            CONVERT TO SERVICE REQUEST W.O.
                          </Button>
                        
                  }
                  </Col>
                  {
                    (props?.request?.data?.status === 1 || props?.request?.data?.status === 2) && updateOrderButtonStatus === 'edit' &&
                      <Row>
                        <Col lg="4">
                          <Button
                            className="btn-dark"
                            style={{backgroundColor:"red", margin:5}}
                            onClick={()=>{
                              if(props?.request?.data?.status === 1){
                                if(window.confirm(`Are you sure you want to delete work order ${props?.request?.data?.["client name"]}`)){
                                  deleteWorkOrder(props?.request?.id);
                                }
                              }
                              if(props?.request?.data?.status === 2){
                                if(window.confirm(`Are you sure you want to delete work order ${workOrderNo}`)){
                                  deleteWorkOrder(props?.request?.id);
                                }
                              }
                            }}
                          >
                            DELETE
                          </Button>
                        </Col>
                      </Row>  
                  }
                  {/*
                    workCompleted &&
                    <Col lg="4">
                      <Button 
                        className="btn-dark"
                        style={{backgroundColor:"#2596be"}}
                        onClick={()=>{
                          setDisplayPrintOptions(!displayPrintOptions);
                          if(printQuoteNumber === null || printTruckCharge === null || printMaterials === null || printMaterialCharges === null || printHours === null){
                            if(quoteNo === ""){
                              setPrintQuoteNumber(false);
                              setPrintTruckCharge(true);
                              setPrintMaterials(true);
                              setPrintMaterialCharges(true);
                              setPrintHours(true);
                            }else{
                              setPrintQuoteNumber(true);
                              setPrintTruckCharge(false);
                              setPrintMaterials(true);
                              setPrintMaterialCharges(false);
                              setPrintHours(false);
                            }
                          }
                        }}
                      >
                        Print Options
                      </Button>
                    </Col>
                      */}
                </Row>
                <Row>
                  {
                    workCompleted && updateOrderButtonStatus === 'edit' &&
                      <Col lg="4">
                        <Button 
                          className="btn-dark"
                          style={{backgroundColor:"#2596be", margin:5}}
                          onClick={()=>{
                            setFinalizeModalShow(true);
                            if(printQuoteNumber === null || printTruckCharge === null || printMaterials === null || printMaterialCharges === null || printHours === null){
                              if(quoteNo === ""){
                                setPrintQuoteNumber(false);
                                setPrintTruckCharge(true);
                                setPrintMaterials(true);
                                setPrintMaterialCharges(true);
                                setPrintHours(true);
                              }else{
                                setPrintQuoteNumber(true);
                                setPrintTruckCharge(false);
                                setPrintMaterials(true);
                                setPrintMaterialCharges(false);
                                setPrintHours(false);
                              }
                            }
                          }}
                        >
                          Finalize WO
                        </Button>
                      </Col>
                  }
                </Row>
              </Col>
            </Row>
            {
              displayConvertFields &&
                <Row className="justify-content-center">
                  <Col lg="6" style={{border:"1px solid black", padding:"10px", borderRadius:"10px", marginBottom:"5px"}}>
                    {
                      // bring in fields to save to NEW temp info for Request type, Type of Service, and Details
                      // see CreateRequestModal for GUI example
                      // put a button to call convertToServiceRequest which will run a transaction
                    }
                    <Row style={{marginLeft:"10px"}}><Col>REQUEST TYPE:*</Col></Row>
                    <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}>
                      <Col>
                        <Form.Select as="select" value={convertRequestType} onChange={(e)=> setConvertRequestType(e.target.value)} required>
                            <option value={'service'}>service</option>
                            <option value={'quote'}>quote</option>
                        </Form.Select>
                      </Col>
                    </Row>
                    {
                      convertRequestType === 'service' ?
                        <div>
                            <Row style={{marginLeft:"10px"}}><Col>TYPE OF SERVICE*:</Col></Row>
                            <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}>
                                <Col>
                                    <Form.Select as="select" value={convertRequestType === 'quote' ? '' : convertTypeOfService} onChange={(e)=> setConvertTypeOfService(e.target.value)} required>
                                        <option value={''}></option>
                                        <option value={'No Heat'}>No Heat</option>
                                        <option value={'No AC'}>No AC</option>
                                        <option value={'Other (please provide details)'}>Other (please provide details)</option>    
                                    </Form.Select> 
                                </Col>
                            </Row>
                        </div>
                      :
                        <div></div>
                    }
                    <Row style={{marginLeft:"10px"}}><Col>Details:</Col></Row>
                    <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control as="textarea" value={convertDetails} rows={3} maxLength={inputMaxLengths.details} onChange={(e)=> setConvertDetails(e.target.value)} /></Col></Row>
                    <Row style={{display:'flex', justifyContent:'center'}}>{inputMaxLengths.details - convertDetails.length} characters remaining</Row>
                    <Button 
                      className="btn-dark"
                      style={{backgroundColor:"#2596be", margin:5}}
                      onClick={()=>{
                        if(convertRequestType !== undefined && convertTypeOfService !== undefined && convertDetails !== undefined && convertRequestType === 'service' && convertTypeOfService !== ''){
                          if(props?.request?.data?.status === 1){
                            if(window.confirm(`Are you sure you want to convert this work order ${props?.request?.data?.["client name"]} to a Service Request`)){
                              convertToServiceRequest(props?.request?.id);
                            }
                          }
                          if(props?.request?.data?.status === 2){
                            if(window.confirm(`Are you sure you want to convert this work order ${workOrderNo} to a Service Request`)){
                                convertToServiceRequest(props?.request?.id);
                            }
                          }
                        } else if(convertRequestType !== undefined && convertTypeOfService !== undefined && convertDetails !== undefined && convertRequestType === 'quote'){
                          if(props?.request?.data?.status === 1){
                            if(window.confirm(`Are you sure you want to convert this work order ${props?.request?.data?.["client name"]} to a Service Request`)){
                              convertToServiceRequest(props?.request?.id);
                            }
                          }
                          if(props?.request?.data?.status === 2){
                            if(window.confirm(`Are you sure you want to convert this work order ${workOrderNo} to a Service Request`)){
                                convertToServiceRequest(props?.request?.id);
                            }
                          }
                        } else {
                          alert('Please make sure all information to convert to a Service Request work order is filled out.');
                        }
                      }}
                    >
                      Convert
                    </Button>
                  </Col>
                </Row>
            }
            <Row>
              <Col lg="6" style={{border:"1px solid black", padding:"10px", borderRadius:"10px", marginBottom:"5px"}}>
                <Row style={{marginBottom: "20px"}}><Col>REQUEST DETAILS</Col></Row>
                
                <Row style={{marginLeft:"10px"}}><Col>SERVICE AT:</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={props?.request?.data?.address} disabled /></Col></Row>
                <Row style={{marginLeft:"10px"}}><Col>CUST. PHONE No.</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={props?.request?.data?.['phone number']} disabled /></Col></Row>
                <Row style={{marginLeft:"10px"}}><Col>CUST. AUTHORIZATION/CONTACT:</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={props?.request?.data?.["client name"]} disabled /></Col></Row>
                <Row style={{marginLeft:"10px"}}><Col>CUST. AUTHORIZATION/CONTACT EMAIL ADDRESS:</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={props?.request?.data?.['email address']} disabled /></Col></Row>
                <Row style={{marginLeft:"10px"}}><Col>REQUEST TYPE:</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={props?.request?.data?.type} disabled /></Col></Row>
                <Row style={{marginLeft:"10px"}}><Col>TYPE OF SERVICE:</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={props?.request?.data?.type === 'quote' ? '' : props?.request?.data?.['type of service']} disabled /></Col></Row>
                <Row style={{marginLeft:"10px"}}><Col>Details:</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control as="textarea" value={props?.request?.data?.details} rows={4} disabled /></Col></Row>
                <Row style={{marginLeft:"10px"}}><Col>REQUEST DATE: {timestampToHTMLDateInput(props?.request?.data?.timestamp)}</Col></Row>
                <Row style={{marginLeft:"10px"}}><Col>ID: {props?.request?.id}</Col></Row>
              </Col>
              <Col lg="6" style={{border:"1px solid black", padding:"10px", borderRadius:"10px", marginBottom:"5px"}}>
                <Row style={{marginBottom: "20px"}}>
                  <Col>
                    {
                      props?.request?.data?.status === 1 ? "DISPATCH - CREATE WORK ORDER" : "WORK ORDER"
                    }
                  </Col>
                </Row>
                
                <Row style={{marginLeft:"10px"}}><Col>SERVICE AT:*</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={serviceAt} maxLength={inputMaxLengths.serviceAt} onChange={(e)=> setServiceAt(e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                <Row style={{marginLeft:"10px"}}><Col>CUST. PHONE No.*</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={custPhoneNo} maxLength={inputMaxLengths.custPhoneNo} onChange={(e)=> setCustPhoneNo(e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                <Row style={{marginLeft:"10px"}}><Col>CUST. AUTHORIZATION/CONTACT:*</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={custName} maxLength={inputMaxLengths.custAuthContact} onChange={(e)=> setCustName(e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                <Row style={{marginLeft:"10px"}}><Col>CUST. AUTHORIZATION/CONTACT EMAIL ADDRESS:</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}>
                  <Col>
                    <Form.Control
                      type="text"
                      value={custEmail}
                      onChange={(e)=> {
                        if (emailReg.test(e.target.value) === false && e.target.value !== '') {
                          setEmailTooltip('Not a valid email format, must have an @ sign and a .');
                        } else {
                            setEmailTooltip('');
                        }
                        setCustEmail(e.target.value)
                      }}
                      required
                      disabled={updateOrderButtonStatus === 'edit' ? true : false}
                    />
                  </Col>
                </Row>
                <Row style={{color:'red', display:'flex', justifyContent:'center'}}>{emailTooltip}</Row>
                <Row style={{marginLeft:"10px"}}><Col>REQUEST TYPE:</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}>
                  <Col>
                    <Form.Select as="select" value={requestType} onChange={(e)=> setRequestType(e.target.value)} required disabled={true} >
                      <option value={'maintenance'}>maintenance</option>
                    </Form.Select>
                  </Col>
                </Row>
                <Row style={{marginLeft:"10px"}}><Col>TYPE OF SERVICE:</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}>
                  <Col>
                    <Form.Select
                      as="select"
                      value={typeOfService}
                      onChange={(e)=> {
                        setTypeOfService(e.target.value)
                        if(e.target.value === "Heating" || e.target.value === "Cooling"){
                          setRequestDetails('PM & Inspection of RTUs')
                        }else{
                          setRequestDetails('');
                        }
                      }}
                      required
                      disabled={(updateOrderButtonStatus === 'edit') ? true : false}
                    >
                      <option value={''}></option>
                      <option value={'Heating'}>Heating</option>
                      <option value={'Cooling'}>Cooling</option>
                      <option value={'Other (please provide details)'}>Other (please provide details)</option>
                    </Form.Select> 
                  </Col>
                </Row>
                <Row style={{marginLeft:"10px"}}><Col>Details:</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control as="textarea" value={requestDetails} maxLength={inputMaxLengths.details} onChange={(e)=>{setRequestDetails(e.target.value)}} rows={4} disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                <Row style={{display:'flex', justifyContent:'center'}}>{inputMaxLengths?.details - requestDetails?.length} characters remaining</Row>
                <Row style={{marginLeft:"10px"}}><Col>WORK ORDER No:*</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={workOrderNo} maxLength={inputMaxLengths.workorderNumber} onChange={(e)=> setWorkOrderNo(e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                <Row style={{marginLeft:"10px"}}><Col>QUOTE:</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={quoteNo} maxLength={inputMaxLengths.quoteNumber} onChange={(e)=> setQuoteNo(e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                <Row style={{marginLeft:"10px"}}><Col>QUOTE AMT $:</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="number" value={quoteAmount} maxLength={inputMaxLengths.quoteNumber} onChange={(e)=> {
                    if(e.target.value === ""){
                      setQuoteAmount('')
                    }else{
                      setQuoteAmount(parseFloat(e.target.value))
                    }
                  }}required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                <Row style={{marginLeft:"10px"}}><Col>CUSTOMER:</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={customer} maxLength={inputMaxLengths.customer} onChange={(e)=> setCustomer(e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                <Row style={{marginLeft:"10px"}}><Col>CUSTOMER PURCHASE ORDER:</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={customerPurchaseOrder} maxLength={inputMaxLengths.purchaseOrder} onChange={(e)=> setCustomerPurchaseOrder(e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                
                <Row style={{marginLeft: "10px"}}><Col>DISPATCHED DATE: yyyy-mm-dd</Col></Row>
                <Row style={{marginLeft: "10px", maxWidth:"200px"}}><Col><Form.Control type="date" value={scheduledDate} onChange={(e)=> setScheduledDate(e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                <Row style={{marginLeft: "10px", marginTop:"10px"}}><Col>PRIORITY:</Col></Row>
                <Row style={{marginLeft: "10px", maxWidth:"100px"}}><Col><Form.Control type="number" min="1" max="10" value={scheduledPriority} onChange={(e)=> setScheduledPriority(e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                <Row style={{marginLeft:"10px", marginTop:"10px"}}><Col>ASSIGNED TECHNICIANS: {assignedTechnicians.length}</Col></Row>
                <Row style={{marginLeft:"20px", marginBottom:"10px", maxWidth:"300px"}}>
                  <Form.Control as="select" multiple value={assignedTechnicians} onChange={e => updateAssignedTechnicians(e)} disabled={updateOrderButtonStatus === 'edit' ? true : false} >
                      {
                        technicians.map((tech)=>{
                          return(
                            <option key={tech.id} value={tech.id}>{tech.data.tech_name}</option>
                          )
                        })
                      }
                  </Form.Control>
                </Row>
                <Row style={{marginLeft:"10px", marginTop:"10px"}}><Col>LEAD TECHNICIAN</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}>
                  <Col>
                    <Form.Select as="select" value={leadTech} onChange={(e)=> setLeadTech(e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} >
                      <option value={``}>{``}</option>
                      {
                        assignedTechnicians.map((tech)=>{
                          return(
                            <option
                              key={tech}
                              value={tech}
                            >
                              {
                                technicians.find(searchTech=>searchTech.id === tech).data.tech_name
                              }
                            </option>
                          )
                        })
                      }
                    </Form.Select>
                  </Col>
                </Row>
                <Row style={{marginLeft: "10px", marginTop:"10px"}}><Col>LAST UPDATED: {props?.request?.data?.work_order?.last_saved?.at !== undefined ? timestampToHTMLDateInput(props.request.data.work_order.last_saved.at) : ""}</Col></Row>
                <Row style={{marginLeft: "10px"}}><Col>BY: {props?.request?.data?.work_order?.last_saved?.by !== undefined ? props.request.data.work_order.last_saved.by : ""}</Col></Row>
              </Col>
            </Row>
            <Row>
              {
                workCompleted && updateOrderButtonStatus === 'edit' &&
                  <Col lg="4">
                    <Button 
                      className="btn-dark"
                      style={{backgroundColor:"#2596be", margin:5}}
                      onClick={()=>{
                        setFinalizeModalShow(true);
                      }}
                    >
                      Finalize WO
                    </Button>
                  </Col>
              }
            </Row>
            <Row>
              <Col lg="12" style={{border:"1px solid black", padding:"10px", borderRadius:"10px", marginBottom:"5px"}}>
                <Row style={{marginBottom: "20px"}}>
                  <Col>
                    WORK PERFORMED (Units: {units?.length})
                    {
                      updateOrderButtonStatus === 'save' ?
                        <Button
                          className="btn-dark"
                          style={{backgroundColor:"#2596be", marginLeft:20, width:60}}
                          onClick={()=>{
                            addUnits();
                          }}
                          >
                          <FontAwesomeIcon style={{fontSize: '1.75em'}} icon={faCirclePlus} />
                        </Button>
                      :
                        ""
                    }
                  </Col>
                </Row>
                {
                  units.map((unit, index)=>{
                    return(
                      <Row key={index} style={{margin: 20}}>
                        <Row>
                          UNIT {index+1}
                          {
                            updateOrderButtonStatus === 'save' ?
                              <Button
                                className="btn-dark"
                                style={{backgroundColor:"#2596be", marginLeft:20, width:60}}
                                onClick={()=>{
                                  if(window.confirm(`Are you sure you want to delete UNIT ${index+1}`)){
                                    removeUnits(index);
                                  }
                                }}
                                >
                                <FontAwesomeIcon style={{fontSize: '1.75em'}} icon={faCircleMinus} />
                              </Button>
                            :
                              ""
                          }
                        </Row>
                        <Row><Col>MAKE:</Col></Row>
                        <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={unit?.["Make"]} maxLength={inputMaxLengths.make} onChange={(e)=> updateUnits(index, 'Make', e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                        <Row><Col>MODEL:</Col></Row>
                        <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={unit?.["Model"]} maxLength={inputMaxLengths.model} onChange={(e)=> updateUnits(index, 'Model', e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                        <Row><Col>SERIAL:</Col></Row>
                        <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={unit?.["Serial"]} maxLength={inputMaxLengths.serial} onChange={(e)=> updateUnits(index, 'Serial', e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                        <Row><Col>DESCRIPTION OF WORK PERFORMED:</Col></Row>
                        <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control as="textarea" value={unit?.["Description of Work Performed"]} onChange={(e)=>{updateUnits(index, 'Description of Work Performed', e.target.value)}} rows={8} disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                        <Row><Col>SERVICE RECOMMENDED:</Col></Row>
                        <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control as="textarea" value={unit?.["Service Recommended"]} onChange={(e)=>{updateUnits(index, 'Service Recommended', e.target.value, )}} rows={3} disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                      </Row>
                    )
                  })
                }
              </Col>
            </Row>
            <Row>
              <Col lg="12" style={{border:"1px solid black", padding:"10px", borderRadius:"10px", marginBottom:"5px"}}>
                <Row style={{marginBottom: "20px"}}>
                  <Col>
                    MATERIALS (Entries: {materials?.length})
                    {
                      updateOrderButtonStatus === 'save' ?
                        <Button
                          className="btn-dark"
                          style={{backgroundColor:"#2596be", marginLeft:20, width:60}}
                          onClick={()=>{
                            addMaterials();
                          }}
                          >
                          <FontAwesomeIcon style={{fontSize: '1.75em'}} icon={faCirclePlus} />
                        </Button>
                      :
                        ""
                    }
                  </Col>
                </Row>
                {
                  materials.map((material, index)=>{
                    return(
                      <Row key={index} style={{margin: 20}}>
                        <Row>
                          MATERIAL {index+1}
                          {
                            updateOrderButtonStatus === 'save' ?
                              <Button
                                className="btn-dark"
                                style={{backgroundColor:"#2596be", marginLeft:20, width:60}}
                                onClick={()=>{
                                  if(window.confirm(`Are you sure you want to delete MATERIAL ${index+1}`)){
                                    removeMaterials(index);
                                  }
                                }}
                                >
                                <FontAwesomeIcon style={{fontSize: '1.75em'}} icon={faCircleMinus} />
                              </Button>
                            :
                              ""
                          }
                        </Row>
                        <Row><Col>SOURCE:</Col></Row>
                        <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={material?.["Source"]} maxLength={inputMaxLengths.source} onChange={(e)=> updateMaterials(index, 'Source', e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                        <Row><Col>QTY:</Col></Row>
                        <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="number" min="0" value={material?.["Qty"]} maxLength={inputMaxLengths.qty} onChange={(e)=> updateMaterials(index, 'Qty', e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                        <Row><Col>MATERIAL DESCRIPTION:</Col></Row>
                        <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={material?.["Material Description"]} maxLength={inputMaxLengths.materialDescription} onChange={(e)=> updateMaterials(index, 'Material Description', e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                        <Row><Col>PRICE:</Col></Row>
                        <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="number" min="0" value={material?.["Price"]} onChange={(e)=> updateMaterials(index, 'Price', e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                      </Row>
                    )
                  })
                }
              </Col>
            </Row>
            <Row>
              <Col lg="12" style={{border:"1px solid black", padding:"10px", borderRadius:"10px", marginBottom:"5px"}}>
                <Row style={{marginBottom: "20px"}}>
                  <Col>TRUCK CHARGE</Col>
                  <Col>{
                    updateOrderButtonStatus === 'save' ?
                      <Button
                        className="btn-dark"
                        style={{backgroundColor:"#2596be"}}
                        onClick={()=>{
                          setTruckCharge(defaultTruckCharge);
                          toast.info(`Truck Rate Field updated to ${defaultTruckCharge}, Save work order to confirm.`);
                        }}
                      >
                        Load Default Truck Charge
                      </Button>
                    :
                      ""
                  }</Col>
                </Row>
                <Form.Control 
                  style={{marginLeft:20, width:200}}
                  type="number"
                  min="0" 
                  value={
                    truckCharge
                  }
                  onChange={(e)=> setTruckCharge(e.target.value)}
                  required 
                  disabled={updateOrderButtonStatus === 'edit' ? true : false}
                />
              </Col>
            </Row>
            <Row>
              <Col lg="12" style={{border:"1px solid black", padding:"10px", borderRadius:"10px", marginBottom:"5px"}}>
                <Row style={{marginBottom: "20px"}}>
                  <Col>
                    HOURS (Techs: {hours.filter(tech => assignedTechnicians.includes(tech.techID)).length} of {assignedTechnicians.length})
                    {
                      updateOrderButtonStatus === 'save'  && assignedTechnicians.length > 0 && hours.filter(tech => assignedTechnicians.includes(tech.techID)).length < assignedTechnicians.length ?
                        <Button
                          className="btn-dark"
                          style={{backgroundColor:"#2596be", marginLeft:20, width:60}}
                          onClick={()=>{
                            if(techToAddHours !== "" && techToAddHours !== undefined){
                              addHours();
                            }else{
                              toast.warning('Please select a tech from the drop down');
                            }
                          }}
                          >
                          <FontAwesomeIcon style={{fontSize: '1.75em'}} icon={faCirclePlus} />
                        </Button>
                      :
                        ""
                    }
                    </Col>
                    <Col>
                    {
                      updateOrderButtonStatus === 'save'  && assignedTechnicians.length > 0 && hours.filter(tech => assignedTechnicians.includes(tech.techID)).length < assignedTechnicians.length ?
                        <Form.Select as="select" style={{width:400}} value={techToAddHours} onChange={(e)=> setTechToAddHours(e.target.value) } >
                          <option value={``}>{``}</option>
                          {
                            assignedTechnicians.map((tech)=>{
                              return(
                                <option
                                  key={tech}
                                  value={tech}
                                >
                                  {
                                    hours.filter(e => e.techID === tech).length === 0 &&
                                      technicians.find(searchTech=>searchTech.id === tech).data.tech_name
                                  }
                                </option>
                              )
                            })
                          }
                        </Form.Select>
                      :
                        ""
                    }
                  </Col>
                </Row>
                {
                  hours.map((tech, index)=>{
                    return(
                      assignedTechnicians.includes(tech.techID) ?
                        <Row key={index} style={{marginTop: 20}}>
                          <Row style={{margin: 10}}>
                            <Col>
                              {index + 1}. {technicians.find(searchTech=>searchTech.id === tech.techID).data.tech_name}
                              {
                                updateOrderButtonStatus === 'save' ?
                                  <Button
                                    className="btn-dark"
                                    style={{backgroundColor:"#2596be", marginLeft:20, width:60}}
                                    onClick={()=>{
                                      if(window.confirm(`Are you sure you want to delete HOURS for ${technicians.find(searchTech=>searchTech.id === tech.techID).data.tech_name}`)){
                                        removeHours(index);
                                      }
                                    }}
                                    >
                                    <FontAwesomeIcon style={{fontSize: '1.75em'}} icon={faCircleMinus} />
                                  </Button>
                                :
                                  ""
                              }
                            </Col>
                            <Col>{
                              updateOrderButtonStatus === 'save' ?
                                <Button
                                  className="btn-dark"
                                  style={{backgroundColor:"#2596be"}}
                                  onClick={()=>{
                                    loadCustomerRateHours(index)
                                    toast.info(`Customer Rates for ${technicians.find(searchTech=>searchTech.id === tech.techID).data.tech_name} have been updated, Save work order to confirm.`);
                                  }}
                                >
                                  Use Customer Specific Rates
                                </Button>
                              :
                                ""
                            }
                            </Col>
                            <Col>{
                              updateOrderButtonStatus === 'save' ?
                                <Button
                                  className="btn-dark"
                                  style={{backgroundColor:"#2596be"}}
                                  onClick={()=>{
                                    updateTechRateHours(index, defaultDailyRates)
                                    toast.info(`Daily Rates for this ${technicians.find(searchTech=>searchTech.id === tech.techID).data.tech_name} have been updated, Save work order to confirm.`);
                                  }}
                                >
                                  Load Default Daily Rates
                                </Button>
                              :
                                ""
                            }
                            </Col>
                          </Row>
                          <Row style={{margin: 5}}>
                            <Col>
                              <Row style={{maxWidth:300}}>
                                <Col style={{textAlign:"right"}}>Mon:</Col>
                                <Col>
                                  <Form.Control
                                    style={{marginLeft:0,width:80}}
                                    type="number"
                                    min="0"
                                    onChange={(e)=>{
                                      updateTechHours(index, 'Monday', e.target.value)
                                    }}
                                    value={tech?.Monday}
                                    disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                  />
                                </Col>
                              </Row>
                            </Col>
                            <Col>
                              <Row>
                                Rate: <Form.Control
                                  style={{marginLeft:20,width:80}}
                                  type="number"
                                  min="0"
                                  onChange={(e)=>{
                                    updateTechHours(index, 'Monday Rate', e.target.value)
                                  }}
                                  value={tech?.["Monday Rate"]}
                                  disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                />
                              </Row>
                            </Col>
                            {
                              currentClientInfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                    Premium Hrs:
                                      <Form.Control
                                        style={{marginLeft:20,width:80}}
                                        type="number"
                                        min="0"
                                        onChange={(e)=>{
                                          updateTechHours(index, 'Premium_Monday', e.target.value)
                                        }}
                                        value={tech?.Premium_Monday === undefined ? 0 : tech.Premium_Monday}
                                        disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                      />
                                  </Row>
                                </Col>
                            }
                            {
                              currentClientInfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                    Premium Rate: <Form.Control
                                      style={{marginLeft:20,width:80}}
                                      type="number"
                                      min="0"
                                      onChange={(e)=>{
                                        updateTechHours(index, 'Premium Monday Rate', e.target.value)
                                      }}
                                      value={tech?.["Premium Monday Rate"] === undefined ? 0 : tech["Premium Monday Rate"]}
                                      disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                    />
                                  </Row>
                                </Col>
                            }
                            {
                              currentClientInfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                    {/** ((Total Hours-Premium Hours)*Rate) + (Premium Hours * Premium Rate) = Total */}
                                    $: {((parseFloat(tech?.Monday === "" || tech?.Monday === undefined ? 0 : tech.Monday) - parseFloat(tech?.Premium_Monday === "" || tech?.Premium_Monday === undefined ? 0 : tech.Premium_Monday)) * parseFloat(tech?.["Monday Rate"] === "" || tech?.["Monday Rate"] === undefined ? 0 : tech["Monday Rate"])) + (parseFloat(tech?.Premium_Monday === "" || tech?.Premium_Monday === undefined ? 0 : tech.Premium_Monday) * parseFloat(tech?.["Premium Monday Rate"] === "" || tech?.["Premium Monday Rate"] === undefined ? 0 : tech["Premium Monday Rate"]))}
                                  </Row>
                                </Col>
                            }
                          </Row>
                          <Row style={{margin: 5}}>
                            <Col>
                              <Row style={{maxWidth:300}}>
                                  <Col style={{textAlign:"right"}}>Tue:</Col>
                                  <Col>
                                    <Form.Control
                                      style={{marginLeft:0,width:80}}
                                      type="number"
                                      min="0"
                                      onChange={(e)=>{
                                        updateTechHours(index, 'Tuesday', e.target.value)
                                      }}
                                      value={tech?.Tuesday}
                                      disabled={updateOrderButtonStatus === 'edit' ? true : false} 
                                    />
                                  </Col>
                                </Row>
                              </Col>
                              <Col>
                              <Row>Rate: <Form.Control
                                  style={{marginLeft:20,width:80}}
                                  type="number"
                                  min="0"
                                  onChange={(e)=>{
                                    updateTechHours(index, 'Tuesday Rate', e.target.value)
                                  }}
                                  value={tech?.["Tuesday Rate"] === undefined ? 0 : tech["Tuesday Rate"]}
                                  disabled={updateOrderButtonStatus === 'edit' ? true : false} 
                                />
                              </Row>
                            </Col>
                            {
                              currentClientInfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                      Premium Hrs:
                                        <Form.Control
                                          style={{marginLeft:20,width:80}}
                                          type="number"
                                          min="0"
                                          onChange={(e)=>{
                                            updateTechHours(index, 'Premium_Tuesday', e.target.value)
                                          }}
                                          value={tech?.Premium_Tuesday === undefined ? 0 : tech.Premium_Tuesday}
                                          disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                        />
                                  </Row>
                                </Col>
                            }
                            {
                              currentClientInfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                      Premium Rate: <Form.Control
                                        style={{marginLeft:20,width:80}}
                                        type="number"
                                        min="0"
                                        onChange={(e)=>{
                                          updateTechHours(index, 'Premium Tuesday Rate', e.target.value)
                                        }}
                                        value={tech?.["Premium Tuesday Rate"] === undefined ? 0 : tech["Premium Tuesday Rate"]}
                                        disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                      />
                                  </Row>
                                </Col>
                            }
                            {
                              currentClientInfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                  $: {((parseFloat(tech?.Tuesday === "" || tech?.Tuesday === undefined ? 0 : tech.Tuesday) - parseFloat(tech?.Premium_Tuesday === "" || tech?.Premium_Tuesday === undefined ? 0 : tech.Premium_Tuesday)) * parseFloat(tech?.["Tuesday Rate"] === "" || tech?.["Tuesday Rate"] === undefined ? 0 : tech["Tuesday Rate"])) + (parseFloat(tech?.Premium_Tuesday === "" || tech?.Premium_Tuesday === undefined ? 0 : tech.Premium_Tuesday) * parseFloat(tech?.["Premium Tuesday Rate"] === "" || tech?.["Premium Tuesday Rate"] === undefined ? 0 : tech["Premium Tuesday Rate"]))}
                                  </Row>
                                </Col>
                            }
                          </Row>
                          <Row style={{margin: 5}}>
                            <Col>
                              <Row style={{maxWidth:300}}>
                                <Col style={{textAlign:"right"}}>Wed:</Col>
                                <Col>
                                  <Form.Control
                                    style={{marginLeft:0,width:80}}
                                    type="number"
                                    min="0"
                                    onChange={(e)=>{
                                      updateTechHours(index, 'Wednesday', e.target.value)
                                    }}
                                    value={tech?.Wednesday}
                                    disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                  />
                                </Col>
                              </Row>
                            </Col>
                            <Col>
                              <Row>Rate: <Form.Control
                                  style={{marginLeft:20,width:80}}
                                  type="number"
                                  min="0"
                                  onChange={(e)=>{
                                    updateTechHours(index, 'Wednesday Rate', e.target.value)
                                  }} 
                                  value={tech?.["Wednesday Rate"]}
                                  disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                />
                              </Row>
                            </Col>
                            {
                              currentClientInfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                    Premium Hrs:
                                      <Form.Control
                                        style={{marginLeft:20,width:80}}
                                        type="number"
                                        min="0"
                                        onChange={(e)=>{
                                          updateTechHours(index, 'Premium_Wednesday', e.target.value)
                                        }}
                                        value={tech?.Premium_Wednesday === undefined ? 0 : tech.Premium_Wednesday}
                                        disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                      />
                                  </Row>
                                </Col>
                            }
                            {
                              currentClientInfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                    Premium Rate: <Form.Control
                                      style={{marginLeft:20,width:80}}
                                      type="number"
                                      min="0"
                                      onChange={(e)=>{
                                        updateTechHours(index, 'Premium Wednesday Rate', e.target.value)
                                      }}
                                      value={tech?.["Premium Wednesday Rate"] === undefined ? 0 : tech["Premium Wednesday Rate"]}
                                      disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                    />
                                  </Row>
                                </Col>
                            }
                            {
                              currentClientInfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                    $: {((parseFloat(tech?.Wednesday === "" || tech?.Wednesday === undefined ? 0 : tech.Wednesday) - parseFloat(tech?.Premium_Wednesday === "" || tech?.Premium_Wednesday === undefined ? 0 : tech.Premium_Wednesday)) * parseFloat(tech?.["Wednesday Rate"] === "" || tech?.["Wednesday Rate"] === undefined ? 0 : tech["Wednesday Rate"])) + (parseFloat(tech?.Premium_Wednesday === "" || tech?.Premium_Wednesday === undefined ? 0 : tech.Premium_Wednesday) * parseFloat(tech?.["Premium Wednesday Rate"] === "" || tech?.["Premium Wednesday Rate"] === undefined ? 0 : tech["Premium Wednesday Rate"]))}
                                  </Row>
                                </Col>
                            }
                          </Row>
                          <Row style={{margin: 5}}>
                            <Col>
                              <Row style={{maxWidth:300}}>
                                <Col style={{textAlign:"right"}}>Thu:</Col>
                                <Col>
                                  <Form.Control
                                    style={{marginLeft:0,width:80}}
                                    type="number"
                                    min="0"
                                    onChange={(e)=>{
                                      updateTechHours(index, 'Thursday', e.target.value)
                                    }}
                                    value={tech?.Thursday}
                                    disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                  />
                                </Col>
                              </Row>
                            </Col>
                            <Col>
                              <Row>Rate: <Form.Control
                                  style={{marginLeft:20,width:80}}
                                  type="number"
                                  min="0"
                                  onChange={(e)=>{
                                    updateTechHours(index, 'Thursday Rate', e.target.value)
                                  }}
                                  value={tech?.["Thursday Rate"]}
                                  disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                />
                              </Row>
                            </Col>
                            {
                              currentClientInfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                    Premium Hrs:
                                      <Form.Control
                                        style={{marginLeft:20,width:80}}
                                        type="number"
                                        min="0"
                                        onChange={(e)=>{
                                          updateTechHours(index, 'Premium_Thursday', e.target.value)
                                        }}
                                        value={tech?.Premium_Thursday === undefined ? 0 : tech.Premium_Thursday}
                                        disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                      />
                                  </Row>
                                </Col>
                            }
                            {
                              currentClientInfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                    Premium Rate: <Form.Control
                                      style={{marginLeft:20,width:80}}
                                      type="number"
                                      min="0"
                                      onChange={(e)=>{
                                        updateTechHours(index, 'Premium Thursday Rate', e.target.value)
                                      }}
                                      value={tech?.["Premium Thursday Rate"] === undefined ? 0 : tech["Premium Thursday Rate"]}
                                      disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                    />
                                  </Row>
                                </Col>
                            }
                            {
                              currentClientInfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                    $: {((parseFloat(tech?.Thursday === "" || tech?.Thursday === undefined ? 0 : tech.Thursday) - parseFloat(tech?.Premium_Thursday === "" || tech?.Premium_Thursday === undefined ? 0 : tech.Premium_Thursday)) * parseFloat(tech?.["Thursday Rate"] === "" || tech?.["Thursday Rate"] === undefined ? 0 : tech["Thursday Rate"])) + (parseFloat(tech?.Premium_Thursday === "" || tech?.Premium_Thursday === undefined ? 0 : tech.Premium_Thursday) * parseFloat(tech?.["Premium Thursday Rate"] === "" || tech?.["Premium Thursday Rate"] === undefined ? 0 : tech["Premium Thursday Rate"]))}
                                  </Row>
                                </Col>
                            }
                          </Row>
                          <Row style={{margin: 5}}>
                            <Col>
                              <Row style={{maxWidth:300}}>
                                <Col style={{textAlign:"right"}}>Fri:</Col>
                                <Col>
                                  <Form.Control
                                    style={{marginLeft:0,width:80}}
                                    type="number"
                                    min="0"
                                    onChange={(e)=>{
                                      updateTechHours(index, 'Friday', e.target.value)
                                    }}
                                    value={tech?.Friday}
                                    disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                  />
                                </Col>
                              </Row>
                            </Col>
                            <Col>
                              <Row>Rate: <Form.Control
                                  style={{marginLeft:20,width:80}}
                                  type="number"
                                  min="0"
                                  onChange={(e)=>{
                                    updateTechHours(index, 'Friday Rate', e.target.value)
                                  }}
                                  value={tech?.["Friday Rate"]}
                                  disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                />
                              </Row>
                            </Col>
                            {
                              currentClientInfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                    Premium Hrs:
                                      <Form.Control
                                        style={{marginLeft:20,width:80}}
                                        type="number"
                                        min="0"
                                        onChange={(e)=>{
                                          updateTechHours(index, 'Premium_Friday', e.target.value)
                                        }}
                                        value={tech?.Premium_Friday === undefined ? 0 : tech.Premium_Friday}
                                        disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                      />
                                  </Row>
                                </Col>
                            }
                            {
                              currentClientInfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                    Premium Rate: <Form.Control
                                      style={{marginLeft:20,width:80}}
                                      type="number"
                                      min="0"
                                      onChange={(e)=>{
                                        updateTechHours(index, 'Premium Friday Rate', e.target.value)
                                      }}
                                      value={tech?.["Premium Friday Rate"] === undefined ? 0 : tech["Premium Friday Rate"]}
                                      disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                    />
                                  </Row>
                                </Col>
                            }
                            {
                              currentClientInfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                    $: {((parseFloat(tech?.Friday === "" || tech?.Friday === undefined ? 0 : tech.Friday) - parseFloat(tech?.Premium_Friday === "" || tech?.Premium_Friday === undefined ? 0 : tech.Premium_Friday)) * parseFloat(tech?.["Friday Rate"] === "" || tech?.["Friday Rate"] === undefined ? 0 : tech["Friday Rate"])) + (parseFloat(tech?.Premium_Friday === "" || tech?.Premium_Friday === undefined ? 0 : tech.Premium_Friday) * parseFloat(tech?.["Premium Friday Rate"] === "" || tech?.["Premium Friday Rate"] === undefined ? 0 : tech["Premium Friday Rate"]))}
                                  </Row>
                                </Col>
                            }
                          </Row>
                          <Row style={{margin: 5}}>
                            <Col>
                              <Row style={{maxWidth:300}}>
                                <Col style={{textAlign:"right"}}>Sat:</Col>
                                <Col>
                                  <Form.Control
                                    style={{marginLeft:0,width:80}}
                                    type="number"
                                    min="0"
                                    onChange={(e)=>{
                                      updateTechHours(index, 'Saturday', e.target.value)
                                    }}
                                    value={tech?.Saturday}
                                    disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                  />
                                </Col>
                              </Row>
                            </Col>
                            <Col>
                              <Row>Rate: <Form.Control
                                  style={{marginLeft:20,width:80}}
                                  type="number"
                                  min="0"
                                  onChange={(e)=>{
                                    updateTechHours(index, 'Saturday Rate', e.target.value)
                                  }}
                                  value={tech?.["Saturday Rate"]}
                                  disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                />
                              </Row>
                            </Col>
                            {
                              currentClientInfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                    Premium Hrs:
                                      <Form.Control
                                        style={{marginLeft:20,width:80}}
                                        type="number"
                                        min="0"
                                        onChange={(e)=>{
                                          updateTechHours(index, 'Premium_Saturday', e.target.value)
                                        }}
                                        value={tech?.Premium_Saturday === undefined ? 0 : tech.Premium_Saturday}
                                        disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                      />
                                  </Row>
                                </Col>
                            }
                            {
                              currentClientInfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                    Premium Rate: <Form.Control
                                      style={{marginLeft:20,width:80}}
                                      type="number"
                                      min="0"
                                      onChange={(e)=>{
                                        updateTechHours(index, 'Premium Saturday Rate', e.target.value)
                                      }}
                                      value={tech?.["Premium Saturday Rate"] === undefined ? 0 : tech["Premium Saturday Rate"]}
                                      disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                    />
                                  </Row>
                                </Col>
                            }
                            {
                              currentClientInfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                    $: {((parseFloat(tech?.Saturday === "" || tech?.Saturday === undefined ? 0 : tech.Saturday) - parseFloat(tech?.Premium_Saturday === "" || tech?.Premium_Saturday === undefined ? 0 : tech.Premium_Saturday)) * parseFloat(tech?.["Saturday Rate"] === "" || tech?.["Saturday Rate"] === undefined ? 0 : tech["Saturday Rate"])) + (parseFloat(tech?.Premium_Saturday === "" || tech?.Premium_Saturday === undefined ? 0 : tech.Premium_Saturday) * parseFloat(tech?.["Premium Saturday Rate"] === "" || tech?.["Premium Saturday Rate"] === undefined ? 0 : tech["Premium Saturday Rate"]))}
                                  </Row>
                                </Col>
                            }
                          </Row>
                          <Row style={{margin: 5}}>
                            <Col>
                              <Row style={{maxWidth:300}}>
                                <Col style={{textAlign:"right"}}>Sun:</Col>
                                <Col>
                                  <Form.Control
                                    style={{marginLeft:0,width:80}}
                                    type="number"
                                    min="0"
                                    onChange={(e)=>{
                                      updateTechHours(index, 'Sunday', e.target.value)
                                    }}
                                    value={tech?.Sunday}
                                    disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                  />
                                </Col>
                              </Row>
                            </Col>
                            <Col>
                              <Row>Rate: <Form.Control
                                  style={{marginLeft:20,width:80}}
                                  type="number"
                                  min="0"
                                  onChange={(e)=>{
                                    updateTechHours(index, 'Sunday Rate', e.target.value)
                                  }}
                                  value={tech?.["Sunday Rate"]}
                                  disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                />
                              </Row>
                            </Col>
                            {
                              currentClientInfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                    Premium Hrs:
                                      <Form.Control
                                        style={{marginLeft:20,width:80}}
                                        type="number"
                                        min="0"
                                        onChange={(e)=>{
                                          updateTechHours(index, 'Premium_Sunday', e.target.value)
                                        }}
                                        value={tech?.Premium_Sunday === undefined ? 0 : tech.Premium_Sunday}
                                        disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                      />
                                  </Row>
                                </Col>
                            }
                            {
                              currentClientInfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                    Premium Rate: <Form.Control
                                      style={{marginLeft:20,width:80}}
                                      type="number"
                                      min="0"
                                      onChange={(e)=>{
                                        updateTechHours(index, 'Premium Sunday Rate', e.target.value)
                                      }}
                                      value={tech?.["Premium Sunday Rate"] === undefined ? 0 : tech?.["Premium Sunday Rate"]}
                                      disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                    />
                                  </Row>
                                </Col>
                            }
                            {
                              currentClientInfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                    $: {((parseFloat(tech?.Sunday === "" || tech?.Sunday === undefined ? 0 : tech.Sunday) - parseFloat(tech?.Premium_Sunday === "" || tech?.Premium_Sunday === undefined ? 0 : tech.Premium_Sunday)) * parseFloat(tech?.["Sunday Rate"] === "" || tech?.["Sunday Rate"] === undefined ? 0 : tech["Sunday Rate"])) + (parseFloat(tech?.Premium_Sunday === "" || tech?.Premium_Sunday === undefined ? 0 : tech.Premium_Sunday) * parseFloat(tech?.["Premium Sunday Rate"] === "" || tech?.["Premium Sunday Rate"] === undefined ? 0 : tech["Premium Sunday Rate"]))}
                                  </Row>
                                </Col>
                            }
                          </Row>
                          {
                              currentClientInfo?.client_info?.["Allow Premium Hours"] &&
                              <Row style={{margin: 5}}>Formula: ((Total Hours-Premium Hours)*Rate) + (Premium Hours * Premium Rate) = Total</Row>
                          }
                        </Row>
                      :
                        <div key={index}></div>
                    )
                  })
                }
              </Col>
            </Row>
            <Row>
              {
                workCompleted && updateOrderButtonStatus === 'edit' &&
                  <Col lg="4">
                    <Button 
                      className="btn-dark"
                      style={{backgroundColor:"#2596be", margin:5}}
                      onClick={()=>{
                        setFinalizeModalShow(true);
                      }}
                    >
                      Finalize WO
                    </Button>
                  </Col>
              }
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button 
            className="btn-dark"
            style={{backgroundColor:"#2596be"}}
            onClick={()=>{
              props.onHide('show cancel', props.request.id);
            }}
          >
            {updateOrderButtonStatus === 'edit' ? "Close" : "Cancel and Close"}
          </Button>
        </Modal.Footer>
      </Modal>
    )
  };

  const handleForcedClose = ()=>{
    console.log('Force Closed');
    setUpdateOrderButtonStatus('edit');
    setModalShow(false);
  }

  return (
    <>
      <Container fluid style={{width:"100%", paddingLeft:"70px", marginRight:"70px"}}>
        <Container fluid className="mt-5" style={{fontSize:"1.5em", letterSpacing:"0.2em"}}>
            <Row className="justify-content-center" style={{width:"100%"}}>
              MAINTENANCE
            </Row>
            <Row className="justify-content-center" style={{width:"100%", marginTop:10}}>
              <Button
                className="btn-dark"
                style={{backgroundColor:"#2596be", width:300}}
                onClick={()=>{
                  setCreateModalShow(true);
                  //alert("create new maintenance request - coming soon")
                }}
              >
                CREATE MAINTENANCE REQUEST
              </Button>
            </Row>
        </Container>
        <Container fluid className="mt-4">
          <Row>
            <Col lg="6">
                <Card style={{border:"1px solid black"}}>
                    <Card.Header style={{textAlign:"center"}}>NEW MAINTENANCE</Card.Header>
                    <Card.Body style={{textAlign:"left"}}>
                      {
                        newMaintenance.sort((a,b)=>{
                          if(a.data['timestamp'] < b.data['timestamp']) { return -1 }
                          if(a.data['timestamp'] > b.data['timestamp']) { return 1 }
                          return 0;
                        }).map((request, index)=>{
                          modalShow && 
                          request?.data?.work_order?.used?.email !== "" &&
                          request?.data?.work_order?.used?.email !== currentUser.email &&
                          chosenRequest.id === request.id && 
                            handleForcedClose()
                          return(
                            <div
                              key={index}
                              style={
                                request?.data?.work_order?.used?.email !== "" ?
                                  request?.data?.work_order?.used?.email !== undefined ?
                                    {cursor: "pointer", borderBottom:"1px solid lightgrey", color: "red"}
                                  :
                                    {cursor:"pointer", borderBottom:"1px solid lightgrey"}
                                :
                                  {cursor:"pointer", borderBottom:"1px solid lightgrey"}
                              }
                              onClick={async ()=>{
                                console.log(request);
                                if(request?.data?.work_order?.used?.email === "" || request?.data?.work_order?.used?.email === undefined){
                                  setUsageOverride(false);
                                  try{
                                    let hoursData = await loadHours(request.id);
                                    const clientInfo = await loadClientInfo(request.data?.client_id, request.data?.client_location_id);
                                    console.log(hoursData);
                                    console.log(clientInfo);
                                    if(clientInfo?.location_info !== undefined && clientInfo.location_info.length > 0 && clientInfo.location_info[0]["Truck Charge"] !== null){
                                      setDefaultTruckCharge(clientInfo.location_info[0]["Truck Charge"]);
                                    }else if(clientInfo?.client_info?.["Truck Charge"] !== undefined && clientInfo.client_info["Truck Charge"] !== null){
                                      setDefaultTruckCharge(clientInfo.client_info["Truck Charge"]);
                                    }else{
                                      setDefaultTruckCharge(defaultRateInfo.truckCharge);
                                    }
                                    setCurrentWorkOrderHours(hoursData);
                                    setCurrentClientInfo(clientInfo);
                                    setChosenRequest(request);
                                    setModalShow(true);
                                  }catch(error){
                                    toast.error(`Failed to load hours: ${error}`);
                                  }
                                }else if(usageOverride){
                                  setUsageOverride(false);
                                  if(window.confirm(`Are you sure you want to override the current user for Client: ${request.data['client name']}, they will lose any unsaved work`)){
                                    setShowSpinner(true);
                                    const requestRef = doc(db, "requests", request.id);
                                    runTransaction(db, async (transaction)=>{
                                      const requestDoc = await transaction.get(requestRef);
                                      if(!requestDoc.exists()){
                                        throw new Error("Request document does not exist");
                                      }
                                      const newState = {...requestDoc.data(),
                                        work_order: {
                                          ...requestDoc.data().work_order,
                                          used: {email: "", timestamp: ""},
                                        }
                                      };
                                      await transaction.update(requestRef, newState);
                                    }).then(()=>{
                                      setUsageOverride(false);
                                      setShowSpinner(false);
                                      setUpdateOrderButtonStatus('edit');
                                      setModalShow(false);
                                    }).catch((error)=>{
                                      setShowSpinner(false);
                                      console.log(error);
                                      toast.error(`Failed to save data: ${error.message}`);
                                    });
                                  }
                                }
                              }}
                            >
                              {timestampToHTMLDateInput(request.data.timestamp)} - {request.data.type.toUpperCase()}: {request?.data?.work_order?.service_at === undefined ? request.data.address : request.data.work_order.service_at} - {request.data['client name']}
                              {
                                request?.data?.work_order?.used?.email !== "" ?
                                  request?.data?.work_order?.used?.email !== undefined ?
                                    ` - IN USE ${request?.data?.work_order?.used?.email} : ${calcHourTimeStampDiff(request.data.work_order.used.timestamp, currentTimeStamp()).toFixed(1)} hrs`
                                  :
                                    ''
                                :
                                  ''
                              }
                            </div>
                          )
                        })
                      }
                    </Card.Body>
                </Card>
            </Col>
            <Col lg="6">
                <Card style={{border:"1px solid black"}}>
                    <Card.Header style={{textAlign:"center"}}>CREATED WORK ORDERS</Card.Header>
                    <Card.Body style={{textAlign:"left"}}>
                      {
                        createdWorkOrders.sort((a,b)=>{
                          if(a.data['timestamp'] < b.data['timestamp']) { return -1 }
                          if(a.data['timestamp'] > b.data['timestamp']) { return 1 }
                          return 0;
                        }).map((workorder, index)=>{
                          modalShow && 
                          workorder?.data?.work_order?.used?.email !== "" &&
                          workorder?.data?.work_order?.used?.email !== currentUser.email &&
                          chosenRequest.id === workorder.id && 
                            handleForcedClose()
                          return(
                            <div
                              key={index}
                              style={workorder?.data?.work_order?.used?.email !== "" ?
                                {cursor: "pointer", borderBottom:"1px solid lightgrey", color: "red"}
                              :
                                {cursor:"pointer", borderBottom:"1px solid lightgrey"}
                              }
                              onClick={async ()=>{
                                console.log(workorder);
                                if(workorder?.data?.work_order?.used?.email === ""){
                                  setUsageOverride(false);
                                  try{
                                    let hoursData = await loadHours(workorder.id);
                                    const clientInfo = await loadClientInfo(workorder.data.client_id, workorder.data?.client_location_id);
                                    console.log(hoursData);
                                    console.log(clientInfo);
                                    if(clientInfo?.location_info !== undefined && clientInfo.location_info.length > 0 && clientInfo.location_info[0]["Truck Charge"] !== null){
                                      setDefaultTruckCharge(clientInfo.location_info[0]["Truck Charge"]);
                                    }else if(clientInfo?.client_info?.["Truck Charge"] !== undefined && clientInfo.client_info["Truck Charge"] !== null){
                                      setDefaultTruckCharge(clientInfo.client_info["Truck Charge"]);
                                    }else{
                                      setDefaultTruckCharge(defaultRateInfo.truckCharge);
                                    }
                                    setCurrentWorkOrderHours(hoursData);
                                    setCurrentClientInfo(clientInfo);
                                    setChosenRequest(workorder);
                                    setModalShow(true);
                                  }catch(error){
                                    toast.error(`Failed to load hours: ${error}`);
                                  }
                                }else if(usageOverride){
                                  setUsageOverride(false);
                                  if(window.confirm(`Are you sure you want to override the current user for WO:${workorder.data.work_order.order_number}, they will lose any unsaved work`)){
                                    setShowSpinner(true);
                                    const requestRef = doc(db, "requests", workorder.id);
                                    runTransaction(db, async (transaction)=>{
                                      const requestDoc = await transaction.get(requestRef);
                                      if(!requestDoc.exists()){
                                        throw new Error("Request document does not exist");
                                      }
                                      const newState = {...requestDoc.data(),
                                        work_order: {
                                          ...requestDoc.data().work_order,
                                          used: {email: "", timestamp: ""},
                                        }
                                      };
                                      await transaction.update(requestRef, newState);
                                    }).then(()=>{
                                      setUsageOverride(false);
                                      setShowSpinner(false);
                                      setUpdateOrderButtonStatus('edit');
                                      setModalShow(false);
                                    }).catch((error)=>{
                                      setShowSpinner(false);
                                      console.log(error);
                                      toast.error(`Failed to save data: ${error.message}`);
                                    });
                                  }
                                }
                              }}
                            >
                              {timestampToHTMLDateInput(workorder.data.timestamp)} - {workorder.data.work_order.request_type.toUpperCase()}: {workorder.data.work_order.service_at} - {workorder.data.work_order.order_number}
                              {
                                workorder?.data?.work_order?.used?.email !== "" ?
                                  ` - IN USE ${workorder?.data?.work_order?.used?.email} : ${calcHourTimeStampDiff(workorder.data.work_order.used.timestamp, currentTimeStamp()).toFixed(1)} hrs`
                                :
                                  ''
                              }
                            </div>
                          )
                        })
                      }
                    </Card.Body>
                </Card>
            </Col>
          </Row>
          <Row style={{marginTop:"10px"}}>
            <Col lg="6">
                <Card style={{border:"1px solid black"}}>
                    <Card.Header style={{textAlign:"center"}}>DISPATCHED WORK ORDERS</Card.Header>
                    <Card.Body style={{textAlign:"left"}}>
                      {
                        scheduledWorkOrders.sort((a,b)=>{
                          // if(a.data.work_order.scheduled_date < b.data.work_order.scheduled_date) { return -1 }
                          // if(a.data.work_order.scheduled_date > b.data.work_order.scheduled_date) { return 1 }
                          // if(a.data.work_order.priority < b.data.work_order.priority) {return -1}
                          // if(a.data.work_order.priority > b.data.work_order.priority) {return 1}
                          // return 0;
                          const [a1, a2 = 0] = a.data.work_order.order_number.split('-').map(Number);
                          const [b1, b2 = 0] = b.data.work_order.order_number.split('-').map(Number);

                          if(a1 === b1){
                            return a2-b2;
                          } else {
                            return a1-b1;
                          }
                        }).map((workorder, index)=>{
                          modalShow && 
                          workorder?.data?.work_order?.used?.email !== "" &&
                          workorder?.data?.work_order?.used?.email !== currentUser.email &&
                          chosenRequest.id === workorder.id && 
                            handleForcedClose()
                          return(
                            <div
                              key={index}
                              style={workorder?.data?.work_order?.used?.email !== "" ?
                                {cursor: "pointer", borderBottom:"1px solid lightgrey", color: "red"}
                              :
                                {cursor:"pointer", borderBottom:"1px solid lightgrey"}
                              }
                              onClick={async ()=>{
                                console.log(workorder);
                                if(workorder?.data?.work_order?.used?.email === ""){
                                  setUsageOverride(false);
                                  try{
                                    let hoursData = await loadHours(workorder.id);
                                    const clientInfo = await loadClientInfo(workorder.data.client_id, workorder.data?.client_location_id);
                                    console.log(hoursData);
                                    console.log(clientInfo);
                                    if(clientInfo?.location_info !== undefined && clientInfo.location_info.length > 0 && clientInfo.location_info[0]["Truck Charge"] !== null){
                                      setDefaultTruckCharge(clientInfo.location_info[0]["Truck Charge"]);
                                    }else if(clientInfo?.client_info?.["Truck Charge"] !== undefined && clientInfo.client_info["Truck Charge"] !== null){
                                      setDefaultTruckCharge(clientInfo.client_info["Truck Charge"]);
                                    }else{
                                      setDefaultTruckCharge(defaultRateInfo.truckCharge);
                                    }
                                    setCurrentWorkOrderHours(hoursData);
                                    setCurrentClientInfo(clientInfo);
                                    setChosenRequest(workorder);
                                    setModalShow(true);
                                  }catch(error){
                                    toast.error(`Failed to load hours: ${error}`);
                                  }
                                }else if(usageOverride){
                                  setUsageOverride(false);
                                  if(window.confirm(`Are you sure you want to override the current user for WO:${workorder.data.work_order.order_number}, they will lose any unsaved work`)){
                                    setShowSpinner(true);
                                    const requestRef = doc(db, "requests", workorder.id);
                                    runTransaction(db, async (transaction)=>{
                                      const requestDoc = await transaction.get(requestRef);
                                      if(!requestDoc.exists()){
                                        throw new Error("Request document does not exist");
                                      }
                                      const newState = {...requestDoc.data(),
                                        work_order: {
                                          ...requestDoc.data().work_order,
                                          used: {email: "", timestamp: ""},
                                        }
                                      };
                                      await transaction.update(requestRef, newState);
                                    }).then(()=>{
                                      setUsageOverride(false);
                                      setShowSpinner(false);
                                      setUpdateOrderButtonStatus('edit');
                                      setModalShow(false);
                                    }).catch((error)=>{
                                      setShowSpinner(false);
                                      console.log(error);
                                      toast.error(`Failed to save data: ${error.message}`);
                                    });
                                  }
                                }
                              }}
                            >
                              {timestampToHTMLDateInput(workorder.data.work_order.scheduled_date)} ({workorder.data.work_order.priority}) - {workorder.data.work_order.request_type.toUpperCase()}: {workorder.data.work_order.service_at} - {workorder.data.work_order.order_number}
                              {
                                <div>
                                  Lead Tech: {technicians?.find(searchTech=>searchTech?.id === workorder?.data?.work_order?.lead_tech)?.data?.tech_name}
                                  {
                                    workorder?.data?.work_order?.used?.email !== "" ?
                                      ` - IN USE ${workorder?.data?.work_order?.used?.email} : ${calcHourTimeStampDiff(workorder.data.work_order.used.timestamp, currentTimeStamp()).toFixed(1)} hrs`
                                    :
                                      ''
                                  }
                                </div>
                              }
                            </div>
                          )
                        })
                      }
                    </Card.Body>
                </Card>
            </Col>
            <Col lg="6">
                <Card style={{border:"1px solid black"}}>
                    <Card.Header style={{textAlign:"center"}}>COMPLETED WORK ORDERS</Card.Header>
                    <Card.Body style={{textAlign:"left"}}>
                      {
                        completedWorkOrders.sort((a,b)=>{
                          if(a.data['complete_timestamp'] < b.data['complete_timestamp']) { return -1 }
                          if(a.data['complete_timestamp'] > b.data['complete_timestamp']) { return 1 }
                          return 0;
                        }).map((workorder, index)=>{
                          modalShow && 
                          workorder?.data?.work_order?.used?.email !== "" &&
                          workorder?.data?.work_order?.used?.email !== currentUser.email &&
                          chosenRequest.id === workorder.id && 
                            handleForcedClose()
                          return(
                            <div
                              key={index}
                              style={workorder?.data?.work_order?.used?.email !== "" ? 
                                {cursor: "pointer", borderBottom:"1px solid lightgrey", color: "red"}
                              :
                                {cursor:"pointer", borderBottom:"1px solid lightgrey"}
                              }
                              onClick={async ()=>{
                                console.log(workorder);
                                if(workorder?.data?.work_order?.used?.email === ""){
                                  setUsageOverride(false);
                                  try{
                                    let hoursData = await loadHours(workorder.id);
                                    const clientInfo = await loadClientInfo(workorder.data.client_id, workorder.data?.client_location_id);
                                    console.log(hoursData);
                                    console.log(clientInfo);
                                    if(clientInfo?.location_info !== undefined && clientInfo.location_info.length > 0 && clientInfo.location_info[0]["Truck Charge"] !== null){
                                      setDefaultTruckCharge(clientInfo.location_info[0]["Truck Charge"]);
                                    }else if(clientInfo?.client_info?.["Truck Charge"] !== undefined && clientInfo.client_info["Truck Charge"] !== null){
                                      setDefaultTruckCharge(clientInfo.client_info["Truck Charge"]);
                                    }else{
                                      setDefaultTruckCharge(defaultRateInfo.truckCharge);
                                    }
                                    setCurrentWorkOrderHours(hoursData);
                                    setCurrentClientInfo(clientInfo);
                                    setChosenRequest(workorder);
                                    setModalShow(true);
                                  }catch(error){
                                    toast.error(`Failed to load hours: ${error}`);
                                  }
                                }else if(usageOverride){
                                  setUsageOverride(false);
                                  if(window.confirm(`Are you sure you want to override the current user for WO:${workorder.data.work_order.order_number}, they will lose any unsaved work`)){
                                    setShowSpinner(true);
                                    const requestRef = doc(db, "requests", workorder.id);
                                    runTransaction(db, async (transaction)=>{
                                      const requestDoc = await transaction.get(requestRef);
                                      if(!requestDoc.exists()){
                                        throw new Error("Request document does not exist");
                                      }
                                      const newState = {...requestDoc.data(),
                                        work_order: {
                                          ...requestDoc.data().work_order,
                                          used: {email: "", timestamp: ""},
                                        }
                                      };
                                      await transaction.update(requestRef, newState);
                                    }).then(()=>{
                                      setUsageOverride(false);
                                      setShowSpinner(false);
                                      setUpdateOrderButtonStatus('edit');
                                      setModalShow(false);
                                    }).catch((error)=>{
                                      setShowSpinner(false);
                                      console.log(error);
                                      toast.error(`Failed to save data: ${error.message}`);
                                    });
                                  }
                                }
                              }}
                            >
                              {timestampToHTMLDateInput(workorder.data.complete_timestamp)} - {workorder.data.type.toUpperCase()}: {workorder.data.work_order.service_at} - {workorder.data.work_order.order_number}
                              {
                                <div>
                                  Lead Tech: {technicians?.find(searchTech=>searchTech?.id === workorder?.data?.work_order?.lead_tech)?.data?.tech_name}
                                  {
                                    workorder?.data?.work_order?.used?.email !== "" ?
                                      ` - IN USE ${workorder?.data?.work_order?.used?.email} : ${calcHourTimeStampDiff(workorder.data.work_order.used.timestamp, currentTimeStamp()).toFixed(1)} hrs`
                                    :
                                      ''
                                  }
                                </div>
                              }
                            </div>
                          )
                        })
                      }
                    </Card.Body>
                </Card>
            </Col>
          </Row>
        </Container>
      </Container>
      <Container className="flex align-items-center justify-content-center" style={{minHeight: "10vh"}}>
          <Row className="mt-4">
            <div>
                {currentUser?.email}
            </div>
          </Row>
          <Row className="mt-2">
            <div>
              Override Usage <input type="checkbox" checked={usageOverride} onChange={()=>setUsageOverride(!usageOverride)}/>
            </div>
          </Row>
      </Container>
      {
        showSpinner &&
          <StatusSpinner />
      }
      <RequestModal
        show={modalShow}
        onHide={(cancelBit, id)=> {
            if(cancelBit === 'show cancel' && updateOrderButtonStatus === 'save'){
              toast.warn(`Canceled: No changes were made to the work order.`);
            }
            if(id !== 'none' && id !== undefined){
              const requestRef = doc(db, "requests", id);
              runTransaction(db, async (transaction)=>{
                const requestDoc = await transaction.get(requestRef);
                if(!requestDoc.exists()){
                  throw new Error("Request document does not exist");
                }
                const newState = {...requestDoc.data(),
                  work_order: {
                    ...requestDoc.data().work_order,
                    used: {email: "", timestamp: ""},
                  }
                };
                await transaction.update(requestRef, newState);
              }).then(()=>{
                setShowSpinner(false);
                setUpdateOrderButtonStatus('edit');
                setModalShow(false);
              }).catch((error)=>{
                setShowSpinner(false);
                console.log(error);
                toast.error(`Failed to save data: ${error.message}`);
              });
            }else{
              setModalShow(false);
            }
        }}
        request={chosenRequest}
        currentworkorderhours={currentWorkOrderHours}
      />
      <CreateRequestModal
        show={createModalShow}
        onHide={(cancelBit)=>{
          if(cancelBit === 'show cancel'){
            toast.warn(`Canceled: No request created.`);
          }
          setCreateModalShow(false);
        }}
        modal_type='maintenance'
      />
      <FinalizeRequestModal
        show={finalizeModalShow}
        onHide={(cancelBit)=>{
          if(cancelBit === 'show cancel'){
            toast.warn(`Canceled: Work Order not finalized.`);
            setFinalizeModalShow(false);
          }else{
            setFinalizeModalShow(false);
            setModalShow(false);
          }
        }}
        request={chosenRequest}
        currentworkorderhours={currentWorkOrderHours}
        technicians={technicians}
      />
    </>
  )
}

export default Maintenance